{
  "common": {
    "show": "Näytä",
    "about": "Tietoa",
    "newPost": "Uusi julkaisu",
    "active": "Aktiivinen",
    "change": "Muuta",
    "remove": "Poista",
    "cancel": "Peruuta",
    "publish": "Julkaise",
    "save": "Tallenna",
    "draft": "Luonnos",
    "scheduled": "Ajoitettu",
    "published": "Julkaistu",
    "actions": "Toiminnot",
    "archive": "Arkistoi",
    "delete": "Poista",
    "edit": "Muokkaa",
    "edited": "Muokattu",
    "settings": "Asetukset",
    "signUp": "Rekisteröidy",
    "by": "Viimeistään",
    "for": "–",
    "you": "Sinä",
    "one": "yksi",
    "option": "Vaihtoehto ",
    "registered": "Rekisteröity",
    "to": "–",
    "allEvents": "Kaikki tapahtumat",
    "placeholder": "paikkamerkki",
    "percentOf": "%/",
    "private": "Yksityinen",
    "updatedOn": "Päivitetty",
    "blogPost": "Blogijulkaisu",
    "category": "Kategoria",
    "author": "Tekijä",
    "status": "Tila",
    "errors": {
      "label": "Virheet",
      "SOMETHING_WENT_WRONG": "Jokin meni pieleen. Yritä myöhemmin uudelleen."
    },
    "all": "Kaikki",
    "archived": " Arkistoitu",
    "back": "Takaisin",
    "restore": "Palauta tämä versio",
    "next": "Seuraava",
    "previous": "Edellinen",
    "continue": "Jatka",
    "continueButton": "Jatka",
    "paid": "Maksullinen",
    "free": "Ilmainen",
    "uploadImagesVideos": "Lataa kuvia/videoita",
    "upload": "Lataa",
    "add": "Lisää",
    "on": "Päällä",
    "from": "kohteesta",
    "members": "jäsenet",
    "visibility": "Näkyvyys",
    "public": "Julkinen",
    "description": "Kuvaus",
    "managedBy": "Vastuuhenkilö",
    "noManagers": "Ei vastuuhenkilöitä",
    "noDescription": "Ei kuvausta",
    "more": "lisää",
    "moreCaps": "Lisää",
    "less": "vähemmän",
    "and": "ja",
    "in": "in",
    "allSet": "Olet valmis!",
    "createdBy": "Luonut",
    "home": "Koti",
    "selected": "Valitut",
    "groupMembers": "Ryhmän jäsenet",
    "everyone": "Kaikki",
    "manager": "Vastuuhenkilö",
    "leave": "Poistu",
    "membersList": "Jäsenluettelo",
    "findChannelManagers": "Hae kanavavastaavia",
    "searchGroupMembers": "Hae ryhmän jäseniä",
    "searchMembers": "Hae jäseniä",
    "searchMember": "Hae jäsentä",
    "enterDescription": "Lisää kuvaus",
    "apply": "Käytä",
    "selectRole": "Valitse rooli",
    "people": "Ihmiset",
    "viewProfile": "Näytä profiili",
    "leaderboard": "Tulostaulu",
    "events": "Tapahtumat",
    "logOut": "Kirjaudu ulos",
    "topLevelReached": "Ylin taso saavutettu",
    "topLevelReachedExclaim": "Ylin taso saavutettu!",
    "congratsTopLevel": "Onnittelut! Olet saavuttanut ylimmän tason!",
    "share": "Jaa",
    "copyLink": "Kopioi linkki",
    "reply": "Vastaa",
    "download": "Lataa",
    "noPreviewAvailable": "Esikatselua ei ole saatavilla",
    "userNotFound": "Käyttäjää ei löytynyt",
    "userNotFoundMessage": "Käyttäjää ei löytynyt",
    "thisGroupIsPrivate": "Tämä ryhmä on yksityinen",
    "unableToPreviewPdf": "PDF-tiedoston esikatselu ei onnistu tällä hetkellä. Lataa tiedosto, jotta voit katsoa sen sisällön.",
    "failedToDownloadPdf": "PDF-tiedoston lataaminen epäonnistui",
    "notifyAll": "Ilmoita kaikille kanavalla oleville",
    "communities": "Yhteisöt",
    "courses": "Kurssit",
    "affiliates": "Kumppanit",
    "chats": "Keskustelu",
    "switchToDarkMode": "Vaihda tummaan tilaan",
    "switchToLightMode": "Vaihda vaaleaan tilaan",
    "editProfile": "Muokkaa profiilia",
    "account": "Tili",
    "logout": "Kirjaudu ulos",
    "noResults": "Ei tuloksia",
    "confirmPayment": "Vahvista maksu",
    "done": "Valmis",
    "manage": "HALLINTA",
    "copied": "Kopioitu",
    "submit": "Lähetä",
    "request": "Pyydä",
    "approve": "Hyväksy",
    "decline": "Hylkää",
    "comingSoon": "Tulossa pian",
    "detailsUpdatedSuccessfully": "Tiedot päivitetty",
    "oopsUnableToSaveDetails": "Hups! Tietojen tallentaminen ei onnistu.",
    "verificationFailedPleaseTryAgain": "Vahvistus epäonnistui! Yritä uudelleen",
    "loading": "Ladataan",
    "title": "Otsikko",
    "addLink": "Lisää linkki",
    "writeHere": "Kirjoita tässä",
    "copy": "Kopioi",
    "reset": "Nollaa",
    "register": "Rekisteröidy",
    "search": "Hae",
    "confirm": "Vahvista",
    "success": "Onnistui",
    "toReview": "Arvostelu",
    "invite": "Kutsu",
    "contributions": "Osallistuminen",
    "communitiesSettings": "Yhteisöjen Asetukset",
    "create": "Luo",
    "name": "Nimi",
    "linkCopied": "Linkki Kopioitu!",
    "move": "Siirrä",
    "irreversible": "peruuttamatonta",
    "close": "Sulje",
    "greeting": "Hei, {name}!",
    "managePayments": "Hallinnoida maksuja",
    "manageYourAccount": "Hallinnoida Tili",
    "accountSettings": "Tili Asetukset",
    "proceed": "Jatka",
    "uploading": "Ladataan",
    "retry": "Yritä uudelleen",
    "login": "Kirjaudu sisään",
    "follow": "Seuraa",
    "following": "Seurannassa",
    "followers": "Seuraajat",
    "view": "KATSO",
    "selectAnOption": "Valitse vaihtoehto",
    "channels": "Kanavat",
    "somethingWentWrong": "Jokin meni pieleen. Yritä uudelleen.",
    "switchToNormalMode": "Vaihda tavalliseen tilaan",
    "switchToReadingMode": "Vaihda lukutilaan",
    "goToHomepage": "Siirry etusivulle",
    "onlyGroupOwnersCanCreateCourses": "Vain ryhmän omistajat voivat luoda uusia kursseja",
    "createGroup": "Luo ryhmä",
    "discover": "Discover",
    "continuePayment": "Jatka maksua",
    "invalidCredentials": "Olet antanut virheellisen sähköpostiosoitteen tai salasanan. Yritä uudelleen.",
    "comingUpEvents": "Tulevat tapahtumat!",
    "integratePaymentGateway": "Integroi maksuyhdyskäytävä",
    "connectPaymentGateway": "Yhdistä uusi maksuyhdyskäytävä tai hallinnoi tämänhetkisiä maksukäytäviä.",
    "isLive": "on julkaistu",
    "justNow": "Juuri nyt",
    "likes": "Tykkäykset",
    "accessRequired": "Pääsy*",
    "zeroProgress": "0",
    "noFollowersTitle": "Näyttää siltä, että kukaan ei seuraa sinua.",
    "noFollowersSubtext": "Lisää yhteytesi seurantalistalle",
    "noFollowingTitle": "Et seuraa vielä ketään.",
    "noFollowingSubtext": "Aloita ihmisten seuraaminen, jotta näet heidän julkaisunsa",
    "followBack": "Seuraa takaisin",
    "logIn": "KIRJAUDU SISÄÄN",
    "video": "Video",
    "audio": "Ääni",
    "newVersionAvailable": "Sovelluksestasi on saatavilla uusi versio. Päivitä käyttääksesi tätä ominaisuutta!",
    "ariaLabels": {
      "backButton": "Takaisin-painike",
      "openEventLocation": "Avaa tapahtuman sijainti",
      "editEvent": "Muokkaa tapahtumaa",
      "deleteEvent": "Poista tapahtuma",
      "cancelRsvp": "Peruuta ilmoittautuminen",
      "publicGroupRadio": "Julkinen ryhmä -valintanappi",
      "privateGroupRadio": "Yksityinen ryhmä -valintanappi",
      "accessibleFromSwitcherCheckbox": "Käytettävissä valitsimen kautta -valintaruutu",
      "allowMembersToInviteCheckbox": "Salli jäsenten kutsua -valintaruutu",
      "addMembers": "Lisää jäseniä",
      "settings": "Asetukset",
      "leaveChannel": "Poistu kanavalta",
      "channelSettings": "Kanavan asetukset",
      "selectRole": "Valitse rooli",
      "deleteChannel": "Poista kanava",
      "changeToPrivateChannel": "Vaihda yksityiseen kanavaan",
      "allowMembersToPosts": "Salli jäsenten julkaista viestejä",
      "restrictMembersFromPosts": "Rajoita jäsenten viestien lähettämistä",
      "close": "Sulje",
      "open": "Avaa",
      "more": "Lisää",
      "upload": "Lataa",
      "play": "Toista",
      "pause": "Keskeytä",
      "mute": "Mykistys",
      "unmute": "Poista mykistys",
      "fullscreen": "Koko näytön tila",
      "exitFullscreen": "Poistu koko näytön tilasta",
      "download": "Lataa",
      "share": "Jaa",
      "like": "Tykkäys",
      "comment": "Kommentoi",
      "reply": "Vastaa",
      "pin": "Kiinnitä",
      "unpin": "Irrota kiinnitys",
      "report": "Raportti",
      "copyLink": "Kopioi linkki",
      "embedCode": "Upota koodi",
      "previewImage": "Esikatselukuva",
      "profileImage": "Profiilikuva",
      "coverImage": "Kansikuva",
      "thumbnail": "Pienkuvake",
      "attachment": "Liite",
      "removeAttachment": "Poista liite",
      "uploadFile": "Lataa tiedosto",
      "selectFile": "Valitse tiedosto",
      "searchIcon": "Hakukuvake",
      "menuIcon": "Valikkokuvake",
      "notification": "Ilmoitus",
      "messages": "Viestit",
      "profile": "Profiili",
      "logout": "Kirjaudu ulos",
      "send": "Lähetä",
      "cancel": "Peruuta",
      "submit": "Lähetä",
      "next": "Seuraava",
      "previous": "Edellinen",
      "refresh": "Päivitä",
      "filter": "Suodata",
      "sort": "Järjestele",
      "view": "Katso",
      "expand": "Laajenna",
      "collapse": "Pienennä",
      "downloadFile": "Lataa tiedosto",
      "closeModal": "Sulje modaali",
      "addMedia": "Lisää media",
      "lightModeRadio": "Vaalea tila -valintanappi",
      "darkModeRadio": "Tumma tila -valintanappi",
      "communityThemeRadio": "Yhteisön teema -valintanappi",
      "userProfile": "Käyttäjäprofiili",
      "postActions": "Julkaisutoiminnot",
      "chatWindow": "Keskusteluikkuna",
      "chatActions": "Keskustelutoiminnot",
      "minimizeChat": "Minimoi keskustelu",
      "closeChat": "Sulje keskustelu",
      "commentActions": "Kommenttitoiminnot",
      "replyToComment": "Vastaa kommenttiin",
      "groupLogo": "Ryhmän logo",
      "pinGroupIcon": "Kiinnitä ryhmäkuvake",
      "appSwitcher": "Sovellusvaihtaja",
      "communities": "Yhteisöt",
      "courses": "Kurssit",
      "search": "Hae",
      "giphyLogo": "Giphy-logo",
      "backToConversations": "Takaisin keskusteluihin",
      "commentAttachments": "Kommenttiliitteet",
      "tabSwitcher": "Välilehtivalitsin",
      "eventCover": "Tapahtuman kattavuus",
      "eventCoverPreview": "Tapahtuman kattavuuden esikatselu",
      "selectPaidEvent": "Valitse maksullinen tapahtuma",
      "selectFreeEvent": "Valitse ilmainen tapahtuma",
      "selectCurrency": "Valitse valuutta",
      "logo": "Logo",
      "closeReviewMembershipAnswersModal": "Sulje Tarkista jäsenyysvastaukset -modaali",
      "liveStream": "Suoratoisto",
      "openGroupMembers": "Avaa ryhmän jäsenet",
      "communityBanner": "Yhteisön banneri",
      "home": "Etusivu",
      "mentionItem": "Mainitse kohde",
      "back": "Takaisin",
      "viewGroup": "Katso ryhmä",
      "invitationIcon": "Kutsukuvake",
      "openUserProfile": "Avaa käyttäjäprofiili",
      "closeStream": "Sulje suoratoisto",
      "groupAvatar": "Ryhmän avatar",
      "bannerImage": "Bannerikuva",
      "avatarImage": "Avatar-kuva",
      "userAvatar": "Käyttäjän avatar",
      "eventImage": "Tapahtumakuva",
      "postImage": "Julkaisukuva",
      "channelIcon": "Kanavakuvake",
      "groupIcon": "Ryhmäkuvake",
      "communityIcon": "Yhteisökuvake",
      "memberAvatar": "Jäsenen avatar",
      "creatorAvatar": "Kehittäjän avatar",
      "authorAvatar": "Kirjoittajan avatar",
      "aboutFeaturedPost": "Tietoa esittelyssä olevasta julkaisusta",
      "accountSettings": "Tilin asetukset",
      "addChannel": "Lisää kanava",
      "addCourse": "Lisää kurssi",
      "addEmoji": "Lisää emoji",
      "affiliates": "Kumppanit",
      "announceEvents": "Ilmoita tapahtumista",
      "avatar": "Avatar",
      "badge": "Merkki",
      "camera": "Kamera",
      "cardImage": "Korttikuva",
      "categoryName": "Kategorian nimi",
      "channelList": "Kanavaluettelo",
      "channelSelect": "Kanavan valinta",
      "chatAttachment": "Keskusteluliite",
      "chats": "Keskustelut",
      "closeCourseDetails": "Sulje kurssin tiedot",
      "closeLoginModal": "Sulje kirjautumismodaali",
      "closeMembershipQuestionsModal": "Sulje jäsenyyskysymysten modaali",
      "closePaymentModal": "Sulje maksutapamodaali",
      "commentCard": "Kommenttikortti",
      "communityTheme": "Yhteisön aihe",
      "conversationItem": "Keskustelukohde",
      "conversationSuggestion": "Keskusteluehdotus",
      "createChannel": "Luo kanava",
      "customThemeRadio": "Mukautettu teema -valintanappi",
      "deleteAnswerButton": "Poista vastaus -painike",
      "deleteFile": "Poista tiedosto",
      "editLevelName": "Muokkaa tason nimeä",
      "editProfile": "Muokkaa profiilia",
      "enterEmailAddress": "Anna sähköpostiosoite",
      "featuredIcon": "Esillä oleva symboli",
      "giveAdministrativePrivileges": "Anna ylläpitäjän oikeudet",
      "gokollabLogo": "Gokollab-logo",
      "icon": "Kuvake",
      "image": "Kuva",
      "likeContent": "Tykkää sisällöstä",
      "link": "Linkki",
      "marketplaceGroupSlug": "Marketplace-ryhmän kestolinkki",
      "microphone": "Mikrofoni",
      "nextAttachment": "Seuraava liite",
      "noEvents": "Ei tapahtumia",
      "noCommunitiesIllustration": "Ei yhteisöjä -kuva",
      "noCoursesFound": "Kursseja ei löytynyt",
      "noFollowers": "Ei seuraajia",
      "noFollowing": "Ei seurannassa",
      "noPostsFound": "Julkaisuja ei löytynyt",
      "notificationItem": "Ilmoituskohde",
      "notificationsList": "Ilmoitusluettelo",
      "openEmbeds": "Avaa upotukset",
      "openEmbedsDrawer": "Avaa upotuslaatikko",
      "openEventColor": "Avaa tapahtumaväri",
      "openEventDetails": "Avaa tapahtuman tiedot",
      "permissionNeeded": "Käyttöoikeus tarvitaan",
      "pointsAndLevels": "Pisteet ja tasot",
      "previousAttachment": "Edellinen liite",
      "reactedUser": "Reagoinut käyttäjä",
      "reward": "Palkinto",
      "rewards": "Palkinnot",
      "selectChannel": "Valitse kanava",
      "selectEventOption": "Valitse tapahtumavaihtoehto",
      "selectIcon": "Valitse kuvake",
      "selectTimezone": "Valitse aikavyöhyke",
      "showChannelIcons": "Näytä kanavakuvakkeet",
      "sidebarActionButton": "Sivupalkin toimintapainike",
      "speaker": "Kaiutin",
      "text": "Teksti",
      "thisGroupIsPrivate": "Tämä ryhmä on yksityinen",
      "toReview": "Tarkistettavat",
      "toggleFeaturedPost": "Vaihda kiinnitetty julkaisu",
      "toggleRewardsOptions": "Palkintovaihtoehdot päälle/pois",
      "viewReplies": "Katso vastaukset",
      "courseThumbnail": "kurssin pienkuvake",
      "moreManagers": "lisää vastaavia",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Vaihda julkiseen kanavaan",
      "showMandatoryInfoModal": "Näytä pakollinen profiilimodaalin valintaruutu"
    },
    "placeholders": {
      "groupName": "Ryhmän nimi",
      "groupSlug": "Ryhmän kestolinkki",
      "url": "URL-osoite",
      "enterPrice": "Syötä hinta",
      "enterName": "Lisää nimi",
      "enterEmail": "Anna sähköpostiosoite",
      "selectTimezone": "Valitse aikavyöhyke",
      "selectChannel": "Valitse kanava",
      "enterSkoolGroupUrl": "Syötä Skool-ryhmän URL-osoite"
    },
    "email": "Sähköposti",
    "errorLoadingConversations": "Virhe keskustelujen lataamisessa",
    "noConversations": "Ei keskusteluja"
  },
  "imageUpload": {
    "cropYourAvatar": "Rajaa avataria",
    "dragToReposition": "Siirrä vetämällä",
    "ariaLabels": {
      "imageUploader": "Kuvan lataaja",
      "avatar": "Avatar",
      "clearFile": "Tyhjennä tiedosto",
      "removeAvatar": "Poista profiiliavatar",
      "zoomButton": "Zoom-painike"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Lataa video",
    "addVideoUsingLink": "Lisää video linkin avulla",
    "uploadImage": "Lataa kuva",
    "addVideo": "Lisää video"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Täydennä profiilisi",
    "profileIntentMessage1": "Kasvottomat ja nimettömät yhteisöt tuntuvat oudoilta.",
    "profileIntentMessage2": "Profiilit auttavat herättämään luottamusta ja luomaan yhteenkuuluvuuden tunnetta",
    "complete": "VALMIS",
    "recommendedAspectRatio": "Ladata {types}. Suositeltu Ulkoasu Prosenttiosuus 1:1",
    "addBio": "Lisää bio... (valinnainen)"
  },
  "validations": {
    "nameRequired": "Nimi on pakollinen!",
    "invalidDescription": "Virheellinen kuvaus!"
  },
  "payment": {
    "recurringWithTrial": "Kokeilujakson päätyttyä sinulta veloitetaan {price} {currencySymbol}/{interval}, ja voit peruuttaa tilauksen milloin tahansa.",
    "recurring": "{price} {currencySymbol}/{interval}, peruuta milloin tahansa.",
    "oneTime": "{price} {currencySymbol} – {paymentText}",
    "defaultOneTimeText": "kertaluonteinen jäsenyysmaksu.",
    "totalAmount": "Loppusumma",
    "viewBreakdown": "Näytä erittely",
    "hideBreakdown": "Piilota erittely",
    "subtotal": "Välisumma",
    "salesTax": "Myyntivero",
    "taxesMayApply": "Veroja saatetaan periä kassalla.",
    "inclTax": "Sisältää veron",
    "totalDueToday": "Tänään maksettava summa",
    "trialDays": "{days} päivän kokeilu",
    "securePayments": "Täysin turvalliset ja suojatut maksut",
    "allowToChargeCard": "Lisäämällä korttisi tietosi hyväksyt, että {locationName} veloittaa tulevat maksut tältä kortilta ehtojensa mukaisesti.",
    "address": {
      "country": "Maa",
      "state": "Tila",
      "zipCode": "Postinumero",
      "city": "Kaupunki",
      "addressLine1": "Osoiterivi 1",
      "addressLine2": "Osoiterivi 2 (valinnainen)",
      "streetAndNumber": "Katuosoite ja numero",
      "apartmentAndUnit": "Huoneisto, sviitti, yksikkö, rakennus, kerros jne.",
      "selectCountry": "Valitse maa",
      "selectState": "Valitse osavaltio",
      "calculatingTaxes": "Verolaskelmien tekeminen",
      "continueToPayment": "Jatka maksuun",
      "validationError": "Täytä kaikki pakolliset osoitekentät.",
      "taxInfo": "Käytämme osoitettasi vain sovellettavien verojen laskemiseen."
    },
    "paymentSuccessful": "Maksu onnistui!",
    "errors": {
      "FDS_DECLINED": "Tapahtumasi on hylätty. Ota yhteyttä yrityksen omistajaan."
    }
  },
  "channel": {
    "notifications": {
      "managersEdited": "Vastuuhenkilöiden tiedot on muutettu!",
      "managersAdded": "Vastuuhenkilöt lisätty!",
      "managersAddedToChannel": "vastuuhenkilöä lisätty seuraavaan:",
      "membersAdded": "Jäsenet lisätty onnistuneesti!",
      "memberPostingEnabled": {
        "title": "Päivitetty Jäsenet-julkaisu onnistui",
        "content": "Jäsenet-ilmoitusta on ollut Käytössä"
      },
      "roleUpdated": "Roolin päivitys onnistui!",
      "updatedRoleOf": "Päivitetty rooli: {name}",
      "userRemoved": "Käyttäjän poistaminen onnistui!",
      "removedUserFrom": "Poistettu {name} kohteesta {channelName}",
      "errorOccurred": "Tapahtui virhe",
      "CHANNEL_MEMBER_ROLE_UPDATE_NOT_FOUND": "Roolia ei voitu päivittää, koska tätä jäsentä ei löytynyt.",
      "CHANNEL_MEMBER_ROLE_UPDATE_OWNER_FORBIDDEN": "Tämä toiminto ei ole sallittu ryhmän omistajalle.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_FOUND": "Käyttäjää ei voitu poistaa, koska tätä jäsentä ei löytynyt.",
      "CHANNEL_MEMBER_REMOVE_CHANNEL_NOT_FOUND": "Käyttäjää ei voitu poistaa, koska kanavaa ei löytynyt.",
      "CHANNEL_MEMBER_REMOVE_OWNER_FORBIDDEN": "Ryhmän omistajaa ei voida poistaa kanavalta.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_IN_CHANNEL": "Kyseinen käyttäjä ei kuulu valittuun kanavaan.",
      "updated": {
        "title": "Kanava-asetukset päivitetty",
        "contentPrivate": "Kanava {channelName} on nyt yksityinen",
        "contentPublic": "Kanava {channelName} on nyt julkinen",
        "content": ""
      },
      "deleted": {
        "title": "Kanava poistettu",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Jäsenet lisätty onnistuneesti!",
        "content": "{count} jäsentä lisätty kohteeseen {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Vastuuhenkilöt lisätty!",
        "content": "{count} ylläpitäjää lisätty kohteeseen {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Päivitetty Jäsenet-julkaisu onnistui",
        "content": "Jäsenet-julkaisu on Poistettuna"
      },
      "visibilityChangedToPublic": "Kanava {channelName} on nyt julkinen",
      "visibilityChangedToPrivate": "Kanava {channelName} on nyt yksityinen",
      "created": {
        "title": "Uusi kanava luotu",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Kanavan luominen epäonnistui",
          "content": "Yritä myöhemmin uudelleen"
        },
        "updateFailed": {
          "title": "Kanavan päivittäminen epäonnistui",
          "content": "Yritä myöhemmin uudelleen"
        },
        "managersEditedFailed": {
          "title": "Vastuuhenkilöiden päivittäminen epäonnistui!",
          "content": ""
        },
        "addFailed": {
          "title": "Vastuuhenkilöiden lisääminen epäonnistui!",
          "content": ""
        },
        "addMembersFailed": {
          "title": "Jäsenten lisääminen epäonnistui!",
          "content": ""
        }
      }
    },
    "createChannel": "Luoda KANAVA",
    "updateChannel": "PÄIVITYS KANAVA",
    "addMembers": "Lisää jäseniä",
    "addManagers": "Lisää vastuuhenkilöitä",
    "typeToAddMoreMembers": "Kirjoita lisättävien jäsenten nimet",
    "examplePlaceholder": "esim. Matti tai Maija",
    "makeChannelManager": "Määritä kanavavastaavaksi",
    "removeFromChannelManager": "Poista kanavavastaavan roolista",
    "manager": "Vastuuhenkilö",
    "channelManager": "Kanavavastaava",
    "noMembersFound": "Jäseniä ei löytynyt.",
    "noManagersFound": "Vastuuhenkilöitä ei löytynyt.",
    "removeChannelMember": "Poista kanavan jäsen",
    "removeConfirmationMessage": "Haluatko varmasti poistaa seuraavan:",
    "makeManagerConfirmationMessage": "Haluatko varmasti tehdä henkilöstä",
    "makeManagerConfirmationMessage2": "kanavavastaavan seuraavassa:",
    "channelName": "Kanavan nimi",
    "channelIcon": "Kanavan kuvake",
    "addChannel": "Lisää kanava",
    "editChannel": "Muokata kanavaa",
    "announcementChannel": "ILMOITUS-kanava",
    "noChannelsAvailable": "Ei käytettävissä olevia kanavia",
    "makeChannelPrivate": "Muuta kanava yksityiseksi",
    "makeChannelPrivateMessage": "Rajoita jäsenen pääsyä kaikkiin kanavakeskusteluihin ja ‑vuorovaikutuksiin.",
    "readOnlyChannel": "Lukea luku ‑kanava",
    "readOnlyChannelMessage": "Jäsenet voi Katsoa TÄRKEÄÄ tiedot ja päivitykset, mutta vain ylläpitäjät/omistajat - kanava voi Jakaa tässä.",
    "createPrivateChannel": "Muuta tämä kanava yksityiseksi",
    "createPrivateChannelMessage": "Vain kutsutut Jäsenet . Ei Jäsenet ei näe tätä Tyhjä tilan",
    "allowMembersToPost": "Ota käyttöön Jäsenet Jakaan",
    "allowMembersToPostMessage": "Ottaa käyttöön Jäsenet Luodaan julkaisuja ja palautetta",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Jäet-julkaisujen ottaminen käyttöön Ottaa ottaa käyttöön Jäsenet kanavan Luoda- ja Jakaa-julkaisuihin.",
      "mainMessage2": "Varmista, että Jäsenet ovat tietoisia - uusi lähetys Käyttöoikeudet.",
      "pointer1": "Tämä toiminto voidaan peruuttaa missä tahansa Päivämäärässä.",
      "pointer2": "atok posts Luonut Jäsenet näkyy in Kaikille."
    },
    "privateChannelTooltip": "Sinulla ei ole tämän kanavan käyttöoikeutta",
    "restrictMembersFromPosting": "Rajoita Jäsenet – julkaisu",
    "restrictMembersFromPostingMessage": "Poistaa tekstistä tämä vaihtoehto estää Jäsenet - Luotu Tai muokkaamasta julkaisuja ja palautetta kanavan sisällä.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "Poistaa Jäsenet-julkaisu rajoittaa Jäsenet - Luotu ja julkaisujen jakamista kanavan sisällä.",
      "mainMessage2": "Varmista, että Jäsenet ovat tietoisia - uudet julkaisurajoitukset.",
      "pointer1": "Tämä toiminto voidaan peruuttaa missä tahansa Päivämäärässä.",
      "pointer2": "paras posts Luonut Jäsenet Ennen tätä Muuttaa pysyy näkyvissä in Kaikille."
    },
    "deleteChannel": "Poista kanava",
    "deleteChannelMessage": "Jos poistat kanavan, menetät kaikki siihen liittyvät tiedot pysyvästi.",
    "deleteChannelMessageWithCourse": "Jos poistat kanavan, Jäsenet-tiedot menetetään pysyvästi ja kaikista tähän kanavaan yhdistetyistä Kursseista tulee Julkinen, ellei Sinä/Te poista niitä ensin.",
    "editChannelName": "Muokkaa kanavan nimeä",
    "editChannelDescription": "Muokkaa kanavan kuvausta",
    "channelNamePlaceholder": "esim. Markkinointiraportit",
    "editManagers": "Muokkaa vastuuhenkilöitä",
    "channelManagers": "Kanavavastaavat",
    "leaveChannel": "Poistu kanavalta",
    "leaveChannelConfirmation": "Haluatko Sinä/Te varma Sinä/Te Poistuaa tämän kanavan?",
    "changeToPrivateChannel": "Muuta kanava yksityiseksi",
    "changeToPrivateChannelMessage": "Jos kanava muutetaan yksityiseksi, vain jäsenet voivat käyttää sitä vuorovaikutukseen ja keskusteluihin.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Jos tämän kanavan vaihtaminen Yksityiselle, SLOTMAX Pääsylle siirtyy Valittu Jäsenet ja vain vastuuhenkilöt.",
      "mainMessage2": "Muista Sisällyttää haluamasi Jäsenet Yksityinen-kanavallesi.",
      "pointer1": "Tämä toiminto on",
      "pointer2": "uusi Jäsenet lisätty kanavaan on Pääsy to MENNYT keskusteluja ja vuorovaikutuksia kanavan sisällä."
    },
    "changeToPublicChannel": "Luo julkinen kanava",
    "changeToPublicChannelMessage": "Julkisen kanavan luominen mahdollistaa kaikille ryhmän jäsenille tämän kanavan katselun ja siihen osallistumisen.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Kun tästä kanavasta tehdään julkinen, se on kaikkien ryhmän jäsenten käytössä.",
      "mainMessage2": "Kaikki ryhmän jäsenet voivat katsoa kanavaa ja osallistua siellä.",
      "pointer1": "Kaikki ryhmän jäsenet pääsevät käyttämään tätä kanavaa automaattisesti.",
      "pointer2": "Aiempi kanavan yksityinen sisältö tulee näkyviin kaikille ryhmän jäsenille."
    },
    "publicChannel": "Julkinen kanava",
    "peopleWhoCanManage": "Henkilöt, joilla on hallintaoikeus",
    "addChannelHelperText": "Näytä lisää yhteisö: Lisätä kanavia monipuoliseen keskusteluun, Duet ja yhteys.",
    "privateChannel": "Yksityinen kanava",
    "removeFromChannel": "Poista kanavasta",
    "removeConfirmationMessage2": "tästä kanavasta",
    "findChannelManagers": "Hae kanavavastaavia",
    "removeChannelManager": "Poista kanavavastaava",
    "irreversible": "Toimintoa ei voi peruuttaa"
  },
  "chat": {
    "unblockUser": "Kumoa käyttäjän esto",
    "blockUser": "Estä käyttäjä",
    "blockMessage1": "Et voi enää lähettää viestejä tälle käyttäjälle.",
    "blockMessage2": "Tätä tiliä ei estetä ryhmässä. Saatat edelleen nähdä käyttäjän viestit, kommentit ja reaktiot.",
    "deleteChat": "Poista keskustelu",
    "deleteChatMessage": "Haluatko varmasti poistaa tämän keskustelun?",
    "block": "Estä",
    "conversation": "keskustelu",
    "youPrefix": "Sinä: ",
    "messageNotSent": "Tätä viestiä ei lähetetty",
    "sending": "Lähetetään",
    "youAndUserKnowEachOther": "Sinä ja {name} tunnette toisenne",
    "startConversationWithHi": "Aloita keskustelu sanomalla \"Hei\"",
    "accountSettings": "Tilin asetukset",
    "blockedUserMessage": "Olet estänyt käyttäjän { name }, joten et voi lähettää hänelle viestejä tai saada viestejä häneltä. Poista esto, jos haluat aloittaa keskustelun. Näet luettelon estämistäsi käyttäjistä kohdasta",
    "blockRecipientMessage": "{ name } on estänyt sinut. Et voi lähettää hänelle viestejä tai saada viestejä häneltä.",
    "nothingFound": "Mitään ei löytynyt!",
    "pleaseCheckUsername": "Tarkista käyttäjätunnus ja yritä uudelleen",
    "startChatting": "Aloita keskustelu",
    "noChatYet": "Näyttää siltä, että et ole vielä keskustellut kenenkään kanssa.",
    "noChatYetMessage": "Hae etsimäsi henkilö kontakteista ja aloita keskustelu!",
    "noConversationsFound": "Keskusteluja ei löytynyt",
    "searchMembersAndStartChatting": "Hae jäseniä ja aloita keskustelu",
    "cannotMessageDeletedUser": "Sinä/Te ei voi Ladata viestejä Poistettuun käyttäjälle",
    "message": "Viesti",
    "media": "Media",
    "files": "Tiedostot"
  },
  "comments": {
    "reportComment": "Ilmianna kommentti",
    "reportCommentMessage": "Haluatko varmasti tehdä ilmiannon tästä kommentista?",
    "deleteComment": "Poista kommentti",
    "editComment": "Muokkaa kommenttia",
    "loadMoreReplies": "Lataa lisää vastauksia",
    "deleteCommentMessage": "Haluatko varmasti poistaa tämän kommentin?",
    "writeComment": "Kirjoita kommentti",
    "comment": "KOMMENTTI",
    "cancel": "PERUUTA",
    "save": "TALLENNA",
    "replyingTo": "Vastataan henkilölle",
    "newComment": "uusi kommentti",
    "latest": "Viimeisin",
    "onlyAdminsCanComment": "Vain yhteisön ylläpitäjät voivat kommentoida in kanavassa.",
    "isCommentDisabledForPost": "Kommentit on poistettu käytöstä tälle julkaisulle.",
    "isCommentDisabledErrorContent": "Kirjoittaja tai ryhmän ylläpitäjä on poistanut kommentit käytöstä tälle julkaisulle.",
    "isCommentDisabledErrorTitle": "Kommentit poistettu käytöstä",
    "notifications": {
      "saveComment": "Virhe kommentin tallentamisessa",
      "error": "Jokin meni pieleen. Yritä myöhemmin uudelleen.",
      "COMMENT_CONTENT_SIZE_EXCEEDED": "Kommentin sisältö on liian pitkä. Pienennä kokoa ja yritä uudelleen.",
      "COMMENTS_DISABLED": "Kirjoittaja tai ryhmän ylläpitäjä on poistanut kommentit käytöstä tälle julkaisulle."
    }
  },
  "embeds": {
    "uploadImage": "Lataa kuva",
    "addYoutubeVimeoLoomLink": "Lisää Youtube-, Vimeo- tai Loom-linkki",
    "uploadAttachment": "Lataa PDF-, CSV- tai XLSX-tiedostoja",
    "addAttachment": "Lisää liite",
    "allowedTypes": "SVG, PNG, JPG tai GIF (enint. 800 x 400 pikseliä)",
    "placeholder": "Lisää Youtube-, Vimeo- tai Loom-linkki",
    "uploadVideo": "Lataa/linkitä video",
    "uploadVideoPlaceholder": "Lisää Youtube-, Vimeo- tai Loom-linkki",
    "uploadVideoAllowedTypes": "Lataa MP4-videotiedosto",
    "addEmoji": "Lisää emoji",
    "emojiSuggestion": "Avaa emojivalitsimen",
    "addGif": "Lisää GIF",
    "gifSuggestion": "Avaa GIF-valitsimen",
    "addImage": "Lisää kuva",
    "imageSuggestion": "Avaa gallerian",
    "addVideo": "Lisää video",
    "videoSuggestion": "Avaa gallerian",
    "selectFile": "Valitse tiedosto",
    "attachmentSuggestion": "Avaa tiedostonhallinnan",
    "takePhoto": "Ota valokuva",
    "uploadPhotoVideo": "Lataa valokuva/video",
    "limitExceeded": "Raja ylitetty",
    "limitExceededMessage": "Voit lisätä liitteeksi enintään 4 tiedostoa",
    "errorWhileUploadingFile": "Virhe tiedoston lataamisessa! Yritä uudelleen",
    "notifications": {
      "uploadError": "Virhe ladattaessa tiedostoa palvelimeen",
      "FILE_SIZE_EXCEEDED": "Tiedoston koko ylittää palvelimeen lataamisen rajan 50 Mt.",
      "VIDEO_SIZE_EXCEEDED": "Videon koko ylittää palvelimeen lataamisen rajan 1 Gt."
    },
    "clickToUpload": "Lataa napsauttamalla",
    "orDragAndDrop": "tai vedä ja pudota",
    "validUrl": "Hyväksyttävä URL tarvitaan",
    "enterSomeText": "Kirjoita tekstiä",
    "addLink": "Lisää linkki",
    "text": "Teksti",
    "addVideoLink": "Tai, Sisällyttää a YouTube, Vimeo, Loom, Tai Wistia Video Linkki.",
    "uploadVideoAndImages": "Ladata videoita ja kuvia",
    "recommendedAspectRatio": "Suositeltu ulkoasu Prosenttiosuus {ratio}",
    "addHashtag": "Merkitse kanavia, tapahtumia ja kursseja tageilla",
    "hashtagSuggestion": "Hashtag-ehdotus"
  },
  "tabSwitcher": {
    "discussion": "Keskustelu",
    "learning": "Oppiminen",
    "members": "Jäsenet",
    "people": "Ihmiset",
    "leaderboard": "Tulostaulu",
    "channels": "Kanavat",
    "groups": "Ryhmät",
    "more": "Lisää",
    "home": "Etusivu",
    "discover": "Tutustu",
    "courses": "Kurssit",
    "communities": "Yhteisöt"
  },
  "groupInfo": {
    "pinGroup": "Kiinnitä Ryhmä",
    "unpinGroup": "Irrota Ryhmä kiinnitys",
    "maxPinnedGroupsLimit": "Vain enintään 4 Ryhmää voidaan kiinnittää",
    "publicGroup": "Julkinen ryhmä",
    "privateGroup": "Yksityinen ryhmä",
    "coverImage": "Ryhmän kattavuus",
    "members": "Jäsenet",
    "posts": "Julkaisut",
    "admin": "Ylläpitäjä",
    "settings": "ASETUKSET",
    "inviteMembers": "KUTSU JÄSENIÄ",
    "answerQuestions": "Vastaa kysymyksiin",
    "toJoin": "liittymään seuraavaan: {name}",
    "leaveGroup": "Poistu ryhmästä",
    "leaveGroupConfirmMessage": "Haluatko varmasti poistua tästä ryhmästä? Menetät pääsyn kaikkiin maksullisiin kursseihin, maksullisiin tapahtumiin ja ryhmäjäsenyyteesi.",
    "leaveGroupSuccessTitle": "Olet poistunut ryhmästä",
    "leaveGroupSuccessMessage": "Olet onnistuneesti poistunut ryhmästä.",
    "leaveGroupErrorTitle": "Ryhmästä ei voi poistua.",
    "leaveGroupErrorMessage": "Ryhmästä poistuttaessa meni jotain pieleen. Yritä uudelleen.",
    "groupActions": "Ryhmätoiminnot",
    "changeRole": "Vaihda roolia",
    "removeFromGroup": "Poista ryhmästä",
    "contributor": "Osallistuja",
    "membershipAnswers": "Jäsenyysvastaukset",
    "unbanMember": "Poista jäsenen esto",
    "banFromGroup": "Estä ryhmästä",
    "requestedOn": "Pyydetty",
    "invitedOn": "Kutsuttu",
    "joinedOn": "Liittynyt",
    "noMembersFound": "Jäseniä ei löytynyt.",
    "youAreAllCaughtUp": "Sinä/Te're suurin kiinni—no Jäsenet tässä oikea nyt!",
    "banUserConfirmation": "Haluatko varmasti estää tämän käyttäjän ryhmästä?",
    "deleteContentCheckbox": "Poista Sisältö Luonut tämä käyttäjä",
    "active": "Aktiiviset",
    "admins": "Ylläpitäjät",
    "contributors": "Osallistujat",
    "requested": "Pyynnön tehneet",
    "banned": "Estetyt",
    "invited": "Kutsutut",
    "paymentReceived": "Maksu vastaanotettu",
    "paymentInitiated": "Maksu aloitettu",
    "answeredQuestions": "Vastatut kysymykset",
    "answeredQuestionsMessage": "vastasi seuraavaan liittymiskysymykseen",
    "darkMode": "Tumma tila",
    "darkModeMessage": "Muuta yhteisön visuaalista ilmettä, jos liika kirkkaus tuntuu rasittavan silmiä.",
    "accessGranted": "Olet saanut käyttöoikeuden: voit aloittaa oppimisseikkailusi.",
    "stepIntoAction": "Tuumasta toimeen! Aloitetaan yhteistyö ja pidetään hauskaa yhdessä.",
    "viewMembersAndMemberDetails": "Katso jäsenet ja jäsentiedot",
    "reviewContentReportsAndMore": "Tarkista sisältöilmiannot ja muut",
    "toReview": "Tarkistettavat",
    "switchToOtherGroups": "Vaihda muuhun ryhmään",
    "placeholders": {
      "yourAnswer": "Vastauksesi"
    },
    "notifications": {
      "userBanned": "Käyttäjä on estetty ryhmästä",
      "somethingWentWrong": "Jokin meni pieleen. Yritä myöhemmin uudelleen."
    },
    "membershipSettings": "Jäsenyysasetukset",
    "paymentFailed": "Maksu epäonnistui!",
    "paymentFailedMessage": "Maksu epäonnistui. Pyyntösi liittyä ryhmään on hylätty.",
    "gamification": {
      "addRewards": "Lisää palkintoja",
      "title": "Otsikko",
      "description": "Lisää kuvaus",
      "textbox": "Tekstilaatikko",
      "singleSelect": "Yksi valinta",
      "multipleSelect": "Monivalinta",
      "question": "Kysymys",
      "validations": {
        "titleRequired": "Anna otsikko",
        "descriptionRequired": "Anna kuvaus",
        "somethingWentWrong": "Jokin meni pieleen. Yritä myöhemmin uudelleen.",
        "updatedRewards": "Palkinnot päivitetty"
      },
      "settings": {
        "updatedRewards": "Palkinnot päivitetty"
      }
    },
    "customCode": {
      "advanced": "Edistynyt",
      "testPreview": "Testiesikatselu",
      "enableConfirmationMessage": "Ota se käyttöön vasta, kun olet vahvistanut testiesikatselun",
      "testPreviewMessage": "Tämä avaa uuden välilehden, jossa on yhteisösi testiesikatselu. Voit tarkistaa sen avulla, toimiiko custom-koodisi odotetulla tavalla.",
      "liveMode": "Suora; live; reaaliaikainen tila",
      "customJS": "Mukautettu JS",
      "customCSS": "Mukautettu CSS",
      "trackingCode": "Seurantakoodi",
      "headerCode": "Koodi",
      "footerCode": "Alatunniste Koodi"
    },
    "branding": {
      "brandYourGroup": "Voit muokata ryhmäsi brändi-ilmettä täältä",
      "updateBranding": "Päivitä brändi-ilme",
      "clickToUploadFavicon": "Lataa suosikkikuvake napsauttamalla",
      "dragAndDropFavicon": "Vedä ja pudota {types} (kuvasuhde 1:1)",
      "clickToUploadCover": "Lataa kansikuva napsauttamalla",
      "dragAndDropCover": "Vedä ja pudota {types} (kuvasuhde 16:9)",
      "clickToUploadLogo": "Lataa ryhmän logo napsauttamalla",
      "dragAndDropLogo": "Vedä ja pudota {types} (kuvasuhde 1:1)",
      "aspectRatioMustBe1To1": "Kuvasuhteen tulee olla 1:1",
      "aspectRatioMustBe16To9": "Kuvasuhteen tulee olla 16:9",
      "favicon": "Suosikkikuvake",
      "coverImage": "Kansikuva",
      "logo": "Logo",
      "invalidFileFormat": "Hupsis! Virheellinen tiedostomuoto/-tyyppi.",
      "pleaseUploadImageType": "Tuetut tiedostotyypit: {types}"
    },
    "groupAppearance": {
      "description": "Sinä/Te voi Määrittää Ryhmä Ulkoasu valintasi per tässä",
      "slug": "Päivitä Ryhmä Ulkoasu tässä",
      "colorMode": "Väri",
      "previewTheLook": "Esikatselu miten Ryhmä tulee Ulkoasu in ja Tumma-tilassa",
      "light": "Kevyt",
      "dark": "Tumma",
      "communityTheme": "yhteisö Teema",
      "customTheme": "Mukautettu Teema",
      "windowGradient": "Ikkuna Gradientti",
      "applyGradientColorsToYourSidebarAndTopbar": "Käyttäjää Gradientti-värit sivu- ja yläpalkkiin",
      "labels": {
        "sidebarBackground": "Sivupalkin Tausta",
        "primary": "ENSISIJAINEN",
        "secondary": "Toissijainen",
        "tertiary": "Kolmannen asteen",
        "surface": "Pinta",
        "fontPrimary": "ENSISIJAINEN Fontti",
        "fontSecondary": "Toissijainen fontti",
        "fill": "Täyttää Väri",
        "border": "Reuna",
        "error": "Virhe",
        "background": "Tausta",
        "option": "Vaihtoehto"
      },
      "customThemes": {
        "default": "Oletus",
        "zestyCitrus": "Raikas sitrushedelmä",
        "royalVelvet": "Royal Velvet",
        "sunnyDelight": "Sunny Delight",
        "lushMeadow": "Rehevä niitty",
        "azureDreams": "Azure Dreams",
        "bubblegumBliss": "Bubblegum Bliss",
        "ivoryWhisper": "Norsunluun kuiskaus",
        "midnightDeep": "Midnight Deep"
      },
      "unsavedChanges": "Tallentamaton Dynaaminen",
      "unsavedChangesMessage": "Sinä/Tella on tallentamattomia Teema Dynaamista, haluatko Sinä/Te varma Sinä/Te Kumota the Dynaamisesta?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Mainoslinkit",
      "createPromotionalLinkDescription": "Luo mainoslinkkejä ryhmällesi",
      "addPromotionalLink": "Lisää linkki",
      "deleteLink": "Poista linkki",
      "deleteLinkConfirmation": "Haluatko varmasti poistaa tämän linkin?",
      "labels": {
        "description": "Kuvaus",
        "url": "URL",
        "private": "Yksityinen",
        "privateLinksDescription": "Yksityiset linkit näkyvät vain ryhmän jäsenille"
      },
      "placeholders": {
        "enterLinkDescription": "Lisää linkin kuvaus",
        "enterLinkURL": "Lisää linkin URL-osoite"
      },
      "addPromotionalLinkDescription": "Luoda Mainoslinkit ryhmällesi",
      "ariaLabels": {
        "editLink": "Muokkaa linkkiä",
        "deleteLink": "Poista linkki"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Lisää kysymys",
      "editQuestion": "Muokkaa kysymystä",
      "editLevelName": "Muokkaa tason nimeä",
      "addOption": "Lisää vaihtoehto",
      "level": "Taso",
      "name": "Nimi",
      "addMembersQuestionsDescription": "Lisää kysymyksiä, jotka esitetään ryhmäsi jäsenyyttä hakeville henkilöille",
      "enableMembershipQuestions": "Ota jäsenyyskysymykset käyttöön",
      "membershipQuestions": "Jäsenyyskysymykset",
      "deleteQuestion": "Poista kysymys",
      "deleteQuestionConfirmation": "Haluatko varmasti poistaa tämän kysymyksen?",
      "labels": {
        "textBox": "Tekstilaatikko",
        "singleSelect": "Yksi valinta",
        "multipleSelect": "Monivalinta",
        "enableMembershipQuestions": "Lisätä vähintään yksi Kysymys – Ottaa käyttöön Jäsenyys kysymys"
      },
      "validations": {
        "questionRequired": "Kirjoita kysymys",
        "answerOptionsRequired": "Vähintään kaksi vaihtoehtoa vaaditaan, ja niiden on oltava keskenään erilaisia",
        "somethingWentWrong": "Jokin meni pieleen. Yritä myöhemmin uudelleen.",
        "updatedQuestions": "Ryhmän jäsenyyskysymykset päivitetty",
        "levelNameRequired": "Lisää tason nimi",
        "updatedLevelName": "Tason nimi päivitetty"
      },
      "placeholders": {
        "enterLevelName": "Tason nimi",
        "selectOne": "Valitse yksi",
        "keepItShort": "Älä tee siitä kovin pitkää...",
        "exampleOffer": "esim 10 % Poistettuun Päällä ensimmäinen ostos"
      },
      "privacyNotice": "Ymmärrän, että vastaukseni ovat Arkistoida ja ne näkyvät Ryhmän ylläpitäjille.",
      "ariaLabels": {
        "editQuestion": "Muokkaa kysymystä",
        "deleteQuestion": "Poista kysymys"
      }
    },
    "gamificationAndRewards": {
      "title": "Mukauta tasoja ja palkintoja",
      "description": "Mukauta tasojen nimiä ja lisää palkintoja jäsenaktiivisuuden lisäämiseksi",
      "gamification": "Pelillistäminen",
      "rewards": "Palkinnot",
      "addRewards": "Lisää palkinto",
      "ariaLabels": {
        "toggleGamification": "Pelillistämisasetukset päälle/pois"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Kutsu lähetetty",
      "invitationSentSuccessfullyDescription": "Kutsu lähetetty osoitteeseen {email}",
      "shareGroupLink": "Jaa ryhmäsi linkki",
      "inviteMember": "Kutsu jäsen",
      "inviteMemberDescription": "Kasvata yhteisöäsi kutsumalla uusi jäsen",
      "inviteViaEmail": "Kutsu sähköpostitse",
      "invitedMembersWillBeAutoApproved": "Jäsenkutsun saaneet hyväksytään ryhmän jäseniksi automaattisesti",
      "sendInvite": "LÄHETÄ KUTSU",
      "permissionDenied": "Sinä/Tella ei ole Valtuutus kutsumaan Jäsenetiä. Ota yhteyttä ylläpitäjään.",
      "notifications": {
        "INVITATION_CREATE_UNAUTHORIZED": "Sinulla ei ole oikeutta lähettää kutsuja.",
        "INVITATION_CREATE_GROUP_DISALLOWS_INVITE": "Tämä ryhmä ei salli jäsenten kutsuvan muita.",
        "INVITATION_CREATE_ALREADY_INVITED": "Tämä käyttäjä on jo kutsuttu.",
        "INVITATION_CREATE_ALREADY_MEMBER": "Tämä käyttäjä on jo ryhmän jäsen."
      },
      "labels": {
        "giveAdministrativePrivileges": "Anna ylläpitäjän oikeudet",
        "giveAdministrativePrivilegesDescription": "Salli tämän jäsenen suorittaa mitä tahansa ylläpitotoimia",
        "name": "Nimi",
        "email": "Sähköposti",
        "nameLabel": "Nimi",
        "emailLabel": "Sähköposti"
      },
      "placeholders": {
        "enterName": "Lisää nimi",
        "enterEmail": "Lisää sähköpostiosoite"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Päivitä ryhmän tiedot",
      "updateGroupDetailsDescription": "Päivitä ryhmäsi tiedot tästä",
      "slugNotAvailable": "Ryhmän kestolinkki ei ole käytettävissä",
      "description": "Kuvaile ryhmässä käytävien keskustelujen luonnetta tarkemmin.",
      "publicDescription": "Kuka tahansa voi nähdä ryhmän viestit ja kaikki jäsenet",
      "privateDescription": "Vain jäsenet voivat nähdä ryhmän viestit ja ryhmän muut jäsenet",
      "accessibleFromSwitcher": "Käytettävissä valitsimen kautta",
      "accessibleFromSwitcherDescription": "Ryhmäsi näkyy muille kuin ryhmän jäsenille valitsimessa",
      "allowMembersToInvite": "Ota käyttöön Jäsenet kutsumaan uudet Jäsenet",
      "allowMembersToInviteDescription": "Piilottaa the kutsu Painike for Jäsenet Kunin kääntyi Poistettuna. Jäsenet voi kutsua vain Muu Jos tämä on Käytössä.",
      "showMandatoryInfoModal": "Näyttää pakollisen profiilimodaalin",
      "showMandatoryInfoModalDescription": "Kun toiminto on käytössä, jäseniä kehotetaan täyttämään profiilitietonsa liittyessään ryhmään.",
      "slug": "Ryhmän kestolinkki",
      "discovery": {
        "title": "Löydettävyys",
        "description": "Varmista, että ryhmäsi on miljoonien aktiivisten käyttäjien löydettävissä. Ryhmä näkyy Löydä uutta ‑sivulla, kun sinulla on yli 10 jäsentä.",
        "discoverChannels": "Löytää kanavia",
        "joinGroupToExploreAllChannels": "liitä the Ryhmän tutustumaan kanaviin",
        "categoryIsUsedOnlyOnGokollab": "Kategoriaa käytetään vain Gokollabissa",
        "categoryAutomaticallySuggested": "Tekoäly ehdottaa kategoriaa automaattisesti ryhmäsi otsikon ja kuvauksen perusteella. Jotta ehdotus olisi mahdollisimman tarkka, varmista, että ryhmäsi tiedot vastaavat selvästi sen tarkoitusta ja aiheita.",
        "categoryRefreshLimited": "Kategorian päivitys on rajoitettu yhteen kertaan 24 tunnin välein"
      },
      "placeholders": {
        "description": "Kirjoita lyhyt kuvaus"
      },
      "validations": {
        "nameRequired": "Anna hyväksyttävä ryhmän nimi!",
        "slugRequired": "Anna hyväksyttävä ryhmän kestolinkki!",
        "specialCharacterNotSupported": "Erikoismerkkiä ei tueta",
        "descriptionRequired": "Ryhmän kuvaus on pakollinen!",
        "emailRequired": "Anna hyväksyttävä sähköpostiosoite!",
        "fullNameRequired": "Anna hyväksyttävä nimi!"
      },
      "labels": {
        "groupName": "Ryhmä nimi"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Hallinnoida, sinun Tilaus",
      "viewAndManageGroupSubscriptions": "Katsoa ja Hallinnoida Ryhmä Tilaus",
      "paymentIntegrationMissingMessage": "Integroi in maksut Ottaa käyttöön Maksetturyhmään",
      "price": "Hinta",
      "currency": "Valuutta",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Yksi päivämäärä",
      "priceDeletedAlert": "Maksu Tuote on - Synkronointi, napsauttaa tässä to resync",
      "intervals": {
        "month": "Kuukausi",
        "year": "Vuosi",
        "week": "Viikko",
        "day": "Päivä"
      },
      "addNewPrice": "Lisätä uusi Hinta",
      "editPrice": "Muokata Hinta",
      "addPrice": "Lisätä Hinta",
      "subscriptionType": {
        "recurring": "Toistuva",
        "oneTime": "Yksi päivämäärä"
      },
      "billingPeriod": {
        "monthly": "Kuukausitttainen",
        "annually": "Vuosittain",
        "weekly": "Viikoittainen",
        "daily": "Päivittäinen"
      },
      "ariaLabels": {
        "freeMembership": "Ilmainen jäsenyys -valintanappi",
        "paidMembership": "Maksullinen jäsenyys -valintanappi"
      }
    },
    "menuOptions": {
      "details": "Yksityiskohdat",
      "subscriptions": "Tilaus",
      "branding": "Brändäys",
      "themes": "Teema",
      "tabsConfiguration": "Näytä / Piilota välilehdet",
      "membershipQuestions": "Jäsenyys",
      "gamificationAndRewards": "Pelillistäminen ja palkinnot",
      "links": "Linkit",
      "newsletter": "Uutiskirje",
      "reportedContent": "Ilmiannettu Sisältö",
      "discovery": "Löydettävyys",
      "import": "Tuoda (maahan)"
    },
    "newsletter": {
      "title": "Uutiskirje",
      "subheading": "Oma yhteisötiivistelmä",
      "frequency": "Uutiskirjeen esiintymistaajuus",
      "description": "Yhteenveto tämän ryhmän suosituista julkaisuista, jäsenten toiminnasta ja tapahtumista",
      "time": "Aika",
      "weekday": "Arkipäivä",
      "monthDay": "Kuukauden päivä",
      "lastDay": "Viimeinen päivä",
      "selectFrequency": "Valitse esiintymistaajuus",
      "frequencies": {
        "off": "Pois käytöstä",
        "daily": "Päivittäin",
        "weekly": "Viikoittain",
        "biweekly": "Kahden viikon välein",
        "monthly": "Kuukausittain"
      }
    },
    "tabConfiguration": {
      "title": "Näytä / Piilota välilehdet",
      "description": "Hallitse yhteisössäsi näkyviä välilehtiä. Ota käyttöön tai poista käytöstä kukin välilehti luodaksesi jäsenillesi keskittyneen ja virtaviivaisen käyttökokemuksen.",
      "discussionDescription": "Aloita keskusteluja tai liity niihin jakaaksesi päivityksiä, ideoita ja näkemyksiä yhteisösi kanssa.",
      "learningDescription": "Luo ja hallinnoi kursseja, jotka auttavat jäseniä hankkimaan uusia taitoja tai tietoja.",
      "eventsDescription": "Suunnittele, järjestä ja tarkastele tulevia istuntoja, työpajoja tai yhteisötapahtumia.",
      "leaderboardDescription": "Tunnusta parhaiten suoriutuvat jäsenet ja kannusta terveeseen sitoutumiseen ranking-listojen avulla.",
      "membersDescription": "Hallinnoi kaikkia jäseniä ja rooleja. Tämä välilehti pysyy näkyvissä ylläpitäjille, vaikka se olisi poistettu käytöstä, joten jäsenten hallinnointi on aina käytettävissä.",
      "aboutDescription": "Esittele yhteisösi tarkoitus, arvot ja tausta auttaaksesi jäseniä luomaan yhteyksiä.",
      "discussionTooltip": "Keskustelu on yhteisön keskeinen välilehti, eikä sitä voi poistaa käytöstä",
      "aboutTooltip": "Tietoja-välilehti on välttämätön yhteisön olennaisten tietojen antamiseksi, eikä sitä voi poistaa käytöstä."
    },
    "groupSettings": {
      "groupSettings": "Ryhmä Asetukset",
      "changeGroupType": "Muuttaa Ryhmä Kirjoittaa",
      "changeGroupTypeDescriptionPrivateToPublic": "Dynaaminen a Julkinen Ryhmä tarkoittaa Kesken Pyynnöt on Hyväksytty automaattisesti ja Sisältö tulee julkiseksi. Edetä?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dynaamisesta Yksityisyyksi ryhmä tarkoittaa uudet Jäsenet tarvitsevat Hyväksyntä ja Sisältö pysyy Piilotettuna Hyväksyttyyn asti. Edetä?",
      "changeGroupTypeConfirmation": "Haluatko Sinä/Te varma Sinä/Te Muuttaa Ryhmä Kirjoittaa?",
      "changeGroupTheme": "Muuttaa Ryhmä Teema",
      "changeGroupThemeDescription": "Tämä Muuttaa Teema ryhmälle Jäsenetille. Haluatko Sinä/Te varma Sinä/Te Muuttaa Ryhmä Teemaan?",
      "updatedGroupDetails": "Ryhmä Yksityiskohdat Päivitetty",
      "unableToSaveDetails": "Hupsis! Arkistoida yksityiskohdat ei onnistu.",
      "groupNameIsRequired": "Ryhmän nimi on Pakollinen",
      "groupDescriptionIsRequired": "Ryhmä Kuvaus on Pakollinen",
      "groupSlugIsRequired": "Ryhmä Kestolinkki on Pakollinen",
      "groupSlugMustContainOnly": "Ryhmä Kestolinkki saa sisältää vain Pienet kirjaimet, kirjaimet ja yhdysviivat",
      "groupSlugAlreadyExists": "Ryhmä Kestolinkki on jo olemassa. Käytä toista Kestolinkkia, sillä tämä on jo varattu",
      "groupSlugRestricted": "Tämä kestolinkki vastaa yhtä rajoitetuista yhteisölinkkien avainsanoistamme. Käytä toista kestolinkkiä",
      "pleaseTryAgainLater": "Yrittää myöhemmin uudelleen",
      "unsavedChangesMessage": "Sinä/Tella on tallentamattomia Ryhmä Kestolinkki Dynaaminen, haluatko Sinä/Te varma, että Sinä/Te kumotaa ne?"
    },
    "import": {
      "header": "Tuoda (maahan) Skool- Ryhmä Jäsenet ja heidän Sisältö",
      "credentialDescription": "Anna Skool Sertifikaatti to Tuoda (maahan) your Ryhmä Jäsenet ja niiden Sisältö",
      "csvUploadDescription": "Valita .csv Tiedosto to Tuoda (maahan) yhteystiedot - Skool",
      "loginFailed": "Sinä/Te on kirjoittanut Virheellinen Sähköposti Tai password. Ole hyvä ja Yrittää uudelleen.",
      "proceedWithImport": "Edetä Tuoda (maahan)?",
      "iAgree": "Olen samaa mieltä",
      "importTerms": "Kautta napsauttamalla \"Hyväksyn\" Sinä/Te vahvistaa ja vahvistaa, että Sinä/Te on palkannut meidät itsenäiseksi Sopimuseksi suorittamaan Palvelut Päällä puolestasi. Palvelut Sisällyttää the Siirtää - tiettyjä tietoja, Yksityiskohdat, Sisältö, intellectual Ominaisuudet Tai any Muu Sisältö (\"Tiedot\") - a Julkaistu Platform Tili to a Vastaanotettu Platform Tili. Sinä/Te edustaa ja takaa, että (i) Sinä/Te ovat lailliset Omistaja - Tiedot in Julkaistu Platform Tili, (i) Sinä/Te on Käyttöoikeudet myöntää meille Pääsy to The Julkaistu Platform Tili for Aie - suorittaa Palvelut, ja (iii) Siirtää - tiedot eivät loukkaa minkään kolmannen osapuolen henkistä Ominaisuudet Käyttöoikeudet Tai loukkaavat kolmannen osapuolen sopimuksia. Sinä/Te sitoutuu korvaamaan, puolustamaan ja Pitomaan meitä kaikista kolmannen osapuolen korvausvaatimuksista, jotka johtuvat Tulos - sinun rikkomuksestasi - edellä mainituista edustajista ja takuista.",
      "pleaseDownloadCSV": "Lataa .CSV Tiedosto",
      "step01": "Vaihe 01-",
      "step02": "Vaihe 02-",
      "uploadCSV": "Ladata .CSV",
      "step01Description": "Täyttää in Tai päivitä Ryhmän Jäsenien puuttuvat yksityiskohdat, kuten Gmail, etunimi jne. Varmista, että CSV on in",
      "thisTemplate": "tämä Mallipohja",
      "importCSV": "Tuoda (maahan) .CSV",
      "reSyncData": "Synkronoi tietosi uudelleen Ennen Ladata.",
      "refreshUserList": "Päivitä käyttäjät Luettelo",
      "reSyncDataDescription": "Jos uusi käyttäjät on lisätty in välin, suosittelemme, että Sinä/Te päivittää Luettelo ja Ladata the CSV.",
      "pleaseDontChangeProfileSlug": "Älä muuta Muuttaa Profiili Kestolinkki.",
      "selectFile": "Valita Tiedosto",
      "changeFile": "Muuttaa Tiedosto",
      "importMembersFailedText": "Tämä voi johtua siitä, että heiltä puuttuu Sähköposti Osoite. Ole hyvä ja valitse Tuoda (maahan) Tiedostosi ja Yrittää uudelleen näiden Jäsenettien voimassa olevalla Sähköpostiosoitteella.",
      "upload": "Ladata",
      "tryAgain": "Yrittää uudelleen",
      "importerAnotherGroup": "Start New Import",
      "syncAllPosts": "Synkronointisi Jakaasi ja kommentoi",
      "membersCouldNotBeAdded": "Jäsenetiä ei voitu lisätä Ryhmään.",
      "importMembersSuccess": "Sähköposti on lähetetty osoitteeseen Yksilöllinen ryhmä Jäsenet, vahvistamalla heidän Jäsenyytensä in ja toimittamalla heille Pääsy yksityiset kohdat. Tämä auttaa varmistamaan, että Jäsenet ovat tietoisia ja voi Pääsy Ryhmän kanssa tehokkaasti.",
      "importMembersAdded": "Jäsenet on lisätty Ryhmään onnistuneesti",
      "postsNotSynced": "Jäljellä olevia tointa ei voitu Synkronoida Ryhmään. Tämä voi johtua siitä, että Jakaa Tekijien tuonti ei onnistunut.",
      "migrationFailed": "Siirto epäonnistui. Ole hyvä ja Yrittää uudelleen.",
      "migrationCompleted": "Muuttoliike Tehty!",
      "migrationInProgress": "Siirto käynnissä",
      "createProfile": "Luo profiili",
      "enterCredentials": "Syötä tunnistetiedot",
      "uploadingInProgress": "Ladata in !",
      "listMembers": "Luettelo - Jäsenet on käynnissä",
      "downloaded": "Ladata",
      "uploaded": "ladattu",
      "listPostsDownloaded": "Luettelo - viestit on Ladata.",
      "listPostsDownloading": "Luettelo - julkaisuja on Ladata.",
      "posts": "julkaisuja",
      "members": "Jäsenet",
      "imported": "tuotu",
      "step1": "Vaihe 1",
      "step2": "Vaihe 2",
      "step1Description": "Luoda a Jäsenet Profiili Skool in .",
      "step1Description2": "(sisältää nimi, Id ja salasana)",
      "step2Description": "Osallistu Skool Jäsenet Sertifikaattiin",
      "skoolUrlPlaceholder": "Syötä Skool-ryhmän URL-osoite",
      "emailPlaceholder": "Anna Skoolisi Id",
      "emailTooltip": "Kirjoita sähköposti Jäsenet Skool Tilille",
      "passwordPlaceholder": "Anna Skoolisi salasana",
      "confirm": "Vahvista",
      "validation": {
        "skoolUrl": "Anna kelvollinen Skool-URL-osoite",
        "email": "Sähköposti on Pakollinen",
        "password": "Salasana on Pakollinen"
      }
    },
    "approved": "Hyväksytty",
    "pending": "Kesken",
    "rejected": "Hylätty"
  },
  "invitations": {
    "intent": "Auta tätä yhteisöä kasvamaan!",
    "cancelInvitation": "Peruuta kutsu",
    "inviteMembers": "Kutsu jäseniä osallistumaan tämän yhteisön toimintaan.",
    "inviteLink": "Kutsulinkki",
    "invitationLink": "kutsulinkki",
    "buildYourCommunity": "Rakenna yhteisöäsi!",
    "inviteMembersToCollaborate": "Olet luonut uuden yhteisön! Kutsu jäseniä osallistumaan tämän yhteisön toimintaan.",
    "invite": "Kutsu",
    "basicInformation": "Perustiedot",
    "permissions": "Käyttöoikeudet"
  },
  "createPost": {
    "title": "Luo uusi blogijulkaisu",
    "placeholder": "Mitä mietit?",
    "liveStream": "Suoratoisto",
    "slug": "Blogijulkaisun URL-kestolinkki",
    "titleHelp": "Otsikkoa, kuvausta ja kuvaa käytetään SEO-sisällönkuvauskentässä",
    "nameLabel": "Blogijulkaisun otsikko",
    "nameValidation": "Otsikko on pakollinen",
    "descriptionLabel": "Julkaisun kuvaus",
    "descriptionHelp": "Anna katsojille lyhyt kuvaus, jotta he voivat saada käsityksen julkaisusta. Toimii parhaiten 100–250 merkin välillä",
    "descriptionValidation": "Kuvaus on pakollinen",
    "createLabel": "Luo julkaisu",
    "image": "Blogijulkaisun kuva",
    "imageDescription": "Suositeltu koko on 600 pikseliä * 400 pikseliä",
    "notificationTitle": "Blogijulkaisu luotu",
    "notificationErrorTitle": "Blogijulkaisun luominen epäonnistui",
    "postingIn": "in",
    "editingIn": "Muokkaus in"
  },
  "post": {
    "downloadRecording": "Lataa tallenne",
    "deletePost": "Poista julkaisu",
    "reportPost": "Ilmianna julkaisu",
    "editPost": "Muokkaa julkaisua",
    "createPost": "Luo julkaisu",
    "publish": "Julkaise",
    "publishPost": "Julkaise julkaisu",
    "addChannel": "Lisää kanava",
    "selectChannel": "Valitse kanava",
    "addLink": "Lisää linkki",
    "removeLink": "Poista linkki",
    "update": "Päivitä",
    "unsavedChanges": "Sinulla on tallentamattomia muutoksia",
    "unsavedChangesMessage": "Tallentamattomat muutokset menetetään. Haluatko jatkaa?",
    "unpinFromChannel": "Irrota kiinnitys",
    "unpinFromHome": "Irrota kiinnitys",
    "deletePostConfirmation": "Haluatko varmasti poistaa tämän julkaisun?",
    "reportPostConfirmation": "Haluatko varmasti tehdä ilmiannon tästä julkaisusta?",
    "postNotFound": "Julkaisua ei löytynyt",
    "postNotFoundMessage": "Julkaisu, jota yrität katsoa, on joko poistettu tai sitä ei ole.",
    "loadMoreComments": "Lataa lisää kommentteja",
    "channelNotFound": "Kanavaa ei löytynyt",
    "isCurrentlyLive": "on tällä hetkellä julkaistu",
    "isStartingNow": "alkaa nyt",
    "isHappeningInMinutes": "alkaa {minutes} minuutin kuluttua",
    "isHappeningInHours": "in {hours} tunti | in {hours} tunti",
    "publicChannel": "Julkinen kanava",
    "privateChannel": "Yksityinen kanava",
    "featured": "Esittelyssä",
    "featuredAbout": "Tietoa esittelyssä olevista",
    "noPostsFound": "Julkaisuja ei löytynyt",
    "pinInfo": "Voit kiinnittää ryhmän yläosaan esimerkiksi sääntöjä tai tiettyjä julkaisuja ja hashtageja.",
    "pinInfoEveryone": "Ne näkyvät ryhmän kaikille jäsenille.",
    "pinInfoRemainVisible": "Kiinnitetyt kohteet pysyvät näkyvissä, kunnes irrotat niiden kiinnityksen.",
    "pinInfoNewestItem": "Kun kiinnität kohteita, uusin kohde näkyy ylimpänä.",
    "onlyVisibleToAdmins": "Näkyy vain ylläpitäjille",
    "featuredAboutDescription": "Ylläpitäjäsi ovat kiinnittäneet nämä kohteet ryhmän nähtäväksi.",
    "channelNotFoundMessage": "Et ole enää sen kanavan jäsen, johon yrität päästä, tai kanava on poistettu.",
    "notifications": {
      "unpinned": "Kiinnitys irrotettu!",
      "pinned": "Kiinnitetty!",
      "reported": "Julkaisu on ilmiannettu!",
      "error": "Jokin meni pieleen!",
      "isCommentDisabled": "Kommentit poistettu käytöstä!",
      "isCommentEnabled": "Kommentit käytössä!",
      "createPost": "Virhe viestin luomisessa",
      "editPost": "Virhe muokattaessa julkaisua",
      "POST_CONTENT_SIZE_EXCEEDED": "Julkaisun sisältö on liian suuri. Pienennä kokoa ja yritä uudelleen."
    },
    "movePostToChannel": "Siirtää kanavaan",
    "pin": "Kiinnitä",
    "pinToHome": "Kiinnitä kotiin",
    "pinToChannel": "Kiinnitä kanavaan",
    "whatIsYourTitle": "Mikä on Otsikkosi?",
    "postMovedToChannel": "Jakaa siirretty {channelName} kanavalle",
    "upcomingEvent": "Tuleva tapahtuma",
    "turnOffCommenting": "Poista kommentointi käytöstä",
    "enableComments": "Ota kommentit käyttöön.",
    "disableComments": "Poista kommentit käytöstä",
    "moveToPrivateChannelConfirmation": {
      "title": "Siirrä yksityiseen kanavaan",
      "message": "Olet siirtämässä tätä viestiä yksityiseen kanavaan. Vain kyseisen yksityisen kanavan jäsenet voivat nähdä sen. Haluatko jatkaa?"
    },
    "onlyAdminsCanPost": "Vain yhteisön ylläpitäjät voivat julkaista tällä kanavalla."
  },
  "reaction": {
    "noLikes": "Ei tykkäyksiä",
    "andOthers": "ja {count} muuta"
  },
  "UIConfirmation": {
    "privateGroup": "Tämä ryhmä on yksityinen",
    "privateGroupMessage": "Sinun on oltava tämän ryhmän jäsen, jotta voit tarkastella ryhmän tietoja. Hae jäsenyyttä napsauttamalla Liity ryhmään ‑painiketta."
  },
  "notifications": {
    "noNotificationsYet": "Ei ilmoituksia",
    "whenYouGetNotifications": "Saapuneet ilmoitukset näkyvät tässä",
    "markAllAsRead": "Merkitse kaikki luetuksi",
    "notifications": "Ilmoitukset",
    "all": "Kaikki",
    "unread": "Lukemattomat",
    "checkNotifications": "Kirjaudu sisään, jotta voit tarkistaa ilmoitukset",
    "noNotifications": "Ei ilmoituksia!",
    "redirectedFromOldSlug": {
      "title": "Sinut on uudelleenohjattu päivitettyyn yhteisölinkkiin",
      "content": "Näin on tehty tämän yhteisön SEO-suorituskyvyn parantamiseksi. Päivitä tämä uusi URL-osoite kirjanmerkkeihisi."
    }
  },
  "joinGroupModal": {
    "wahoo": "Hurraa! 🎉 Pyynnön lähettäminen onnistui",
    "reviewRequestSoon": "Ryhmän ylläpitäjät tarkistavat pyyntösi pian. Ole kärsivällinen – ilmoitamme sinulle, kun jäsenyytesi on hyväksytty.",
    "nonMemberMessage": "Sinun on kuuluttava tähän ryhmään, jotta voit tykätä julkaisuista ja kommentoida niitä",
    "subscribeFor": "Tilaa",
    "joinGroup": "LIITY RYHMÄÄN",
    "membershipPending": "Jäsenyys ODOTTAA",
    "viewMembershipAnswers": "Katsoa Jäsenyys",
    "requested": "Pyydetty",
    "dayFreeTrial": "päivän ilmainen kokeilu",
    "notPartOfGroup": "Sinä/Te eivät ole mukana - tätä Ryhmää, Jäsenyys Pyynnöt on in . Kun Ylläpitäjä Hyväksytty on Pyynnöt, ilmoitamme siitä Sinä/Te",
    "pleaseAnswerMembershipQuestions": "Vastaa Jäsenyys-kysymyksiin liittyäksesi tähän ryhmään",
    "answerQuestions": "Vastaa jäsenyyskysymyksiin"
  },
  "userProfilePopover": {
    "active": "Aktiivisena",
    "longAgo": "kauan sitten",
    "chatDisabled": "Tämä käyttäjä on poistanut keskustelunsa käytöstä",
    "pointsToLevelUp": "pistettä seuraavalle tasolle",
    "profile": "Profiili",
    "deletedUser": "Poistettu käyttäjä",
    "joined": "Liittynyt",
    "contributions": "Osallistuminen"
  },
  "courses": {
    "by": "Tekijä",
    "free": "Ilmainen",
    "unknownInstructor": "Tuntematon kouluttaja",
    "courseRestricted": "Tämä kurssi on rajoitettu",
    "courseDeleted": "Tämä kurssi on poistettu",
    "noMatchingCourseFound": "Vastaavia kursseja ei löytynyt",
    "addCourse": "Lisää kurssi",
    "updateCourse": "Päivitä kurssi",
    "access": "Kaikilla jäsenillä on pääsy",
    "unableToAddCourse": "Hups! Kurssin lisääminen ei onnistu",
    "pleaseTryAgainLater": "Yritä myöhemmin uudelleen",
    "paymentIntegrationMissing": "Hups! Maksuintegrointi puuttuu",
    "paymentIntegrationMissingMessage": "Ota maksulliset kurssit käyttöön integroimalla maksut sijaintiin",
    "course": "Kurssi",
    "courseInThisGroup": "olemassa oleva kurssi tässä ryhmässä",
    "courseLinkCopied": "Kurssin linkki kopioitu!",
    "buyNow": "OSTA HETI",
    "locked": "LUKITTU",
    "buyCourse": "OSTA KURSSI",
    "open": "AVAA",
    "moveCard": "Siirrä korttia",
    "courseViewMessage": "Sinun on kuuluttava tähän ryhmään, jotta voit nähdä kurssit.",
    "deleteCourse": "Poista kurssi",
    "deleteCourseConfirmation": "Haluatko varmasti poistaa tämän kurssin?",
    "courseAccessNotGranted": "Kurssin käyttöoikeus on evätty",
    "courseAccessNotGrantedMessage": "Pyrimme myöntämään sinulle kurssin käyttöoikeuden. Päivitä sivu ja yritä hetken kuluttua uudelleen.",
    "autoRenewsAfter": "Uusiutuu automaattisesti, kun on kulunut",
    "oneTimePayment": "Kertamaksu",
    "emptyCoursesMessage": "Tyhjältä näyttää. Täällä ei ole mitään nähtävää",
    "updatedSuccessfully": "Kurssi päivitetty",
    "addedSuccessfully": "Kurssi lisätty",
    "createCourse": "Luo uusi kurssi",
    "emptyCourseLibrary": "Kurssikirjastosi on tyhjä!",
    "createdOutsideGokollabMessage": "Tämä yhteisö luotiin Gokollabin ulkopuolella ja tehtiin löydettäväksi. Voit luoda uusia kursseja kirjautumalla yhteisöön sen lähdealustalta",
    "createCourseOnGokollabMessage": "Luoda uusi kurssi Gokollabissa, jotta se on yhteisösi jäsenten käytettävissä.",
    "or": "tai",
    "createNewOne": "luo uusi",
    "labels": {
      "selectCourse": "Valitse kurssi",
      "courseVisibility": "Kurssin Näkyvyys",
      "courseAccess": "Kurssin käyttöoikeus",
      "coursePrice": "Kurssin hinta",
      "subscriptionType": "Tilaustyyppi",
      "billingPeriod": "Laskutusjakso",
      "testMode": "Testaustila",
      "turnOnTestPayments": "Ota testimaksut käyttöön testikortilla",
      "currency": "Valuutta",
      "trialDays": "Kokeilupäivät",
      "recurring": "Toistuva",
      "free": "Ilmainen",
      "oneTime": "Yksi päivämäärä",
      "refresh": "Päivitä",
      "accessStartsAtDay": "Pääsy alkaa Päivä",
      "maximumYouCanEnterIs365": "Maksimi Sinä/Te voi ilmoittautua on 365",
      "allMembers": "vain Jäsenet",
      "levelUnlock": "Tasainen Avaa",
      "buyNow": "Osta nyt",
      "timeUnlock": "Päivämäärä Avaa lukitus",
      "gamificationLevel": "Pelillistäminen Tasainen",
      "privateChannel": "Yksityinen kanava",
      "private": "Yksityinen",
      "marketingChannel": "Markkinointi",
      "selectCurrency": "Valitse valuutta"
    },
    "placeholders": {
      "enterPrice": "Lisää hinta",
      "enterTrialDays": "Lisää kokeilupäivät",
      "selectCurrency": "Valitse yksi",
      "selectBillingPeriod": "Valitse yksi",
      "billingPeriod": "Valitse laskutuskausi"
    },
    "validations": {
      "validPrice": "Anna hyväksyttävä hinta",
      "required": "Valitse kurssi",
      "validMembershipPrice": "Lisää hyväksyttävä jäsenyyshinta",
      "validTrialDays": "Lisää hyväksyttävä määrä kokeilupäiviä",
      "requiredSubscriptionType": "Valitse tilaustyyppi",
      "courseVisibility": "Ole hyvä ja Valita kurssi Näkyvyys",
      "requiredGamificationLevel": "Ole hyvä ja Valita Pelillistäminen Tasainen",
      "requiredPrivateChannel": "Ole hyvä ja Valita Yksityinen kanava",
      "validAccessStartDay": "Anna hyväksyttävä Pääsy start Päivä"
    },
    "descriptions": {
      "buyNowDescription": "Tämä kurssi on Julkinen oston yhteydessä",
      "timeUnlockDescription": "Jäsenet Avaa Jälkeen X päivää",
      "levelUnlockDescription": "Jäsenet vain tietystä Tasainen voi avata",
      "allMembersDescription": "visa Jäsenet on Pääsy tälle kurssille",
      "privateChannelDescription": "Jäsenet - Yksityinen kanava",
      "privateDescription": "Vain ylläpitäjän myöntämä käyttöoikeus"
    },
    "helperText": {
      "levelBased": "Tasopohjainen",
      "timeLimited": "tunti-Limited",
      "privateBased": "Yksityinen",
      "free": "Ilmainen",
      "levelAvailableAt": "Saatavilla osoitteesta Tasainen 0{value}",
      "timeLimitedAfterJoining": "Julkinen {value} {day} Jälkeen Ryhmään liittymässä",
      "day": "Päivä",
      "days": "päivää",
      "purchaseToUnlockAccess": "Osta tämä kurssi, jotta voit avata Pääsyn lukituksen",
      "privateCourse": "Yksityinen kurssi – Pääsy vain ylläpitäjän myöntämänä",
      "locked": "Tämä kurssi on lukittu",
      "unlockAtLevel": "Tämä kurssi alkaa Tasaisissa {level}",
      "unlockAfterDays": "Tämä kurssi avaa Jälkeenin {days} {dayText}",
      "privateChannelBased": "Yksityinen kanavapohjainen",
      "externalAccess": "Muu ryhmä / tarjous"
    },
    "manageAccess": {
      "manageCourses": "Hallinnoi kursseja",
      "revokeCourseAccess": "Hallinnoi kursseja",
      "grantCoursesAccess": "Myönnä kurssit",
      "removeAccess": "Poista käyttöoikeus",
      "grantAccess": "Myönnä käyttöoikeus",
      "grant": "Myönnä",
      "clear": "Tyhjennä",
      "selectAll": "Valitse kaikki",
      "revokeAccessConfirmTitle": "Poistetaanko kurssin käyttöoikeus?",
      "revokeAccessConfirmMessage": "Haluatko varmasti poistaa käyttöoikeuden kohteeseen \"{courseName}\" käyttäjältä {userName}?",
      "externalAccessTooltip": "Ei voi poistaa: käyttäjällä on pääsy toisesta ryhmästä tai muusta tarjouksesta",
      "cannotRevokeAutoAccess": "Ei voi poistaa: käyttöoikeus myönnetään automaattisesti kurssin asetusten perusteella (maksullinen, taso, aika tai ilmainen)",
      "searchPlaceholder": "Etsi kursseja",
      "noCoursesFound": "Kursseja ei löytynyt",
      "noCoursesSelected": "Kursseja ei ole vielä valittu",
      "noCoursesAvailable": "Myönnettäviä kursseja ei ole",
      "noSearchResults": "Ei hakutuloksia",
      "failedToLoadCourses": "Kurssien lataaminen epäonnistui",
      "accessRevoked": "Kurssin käyttöoikeus poistettiin onnistuneesti",
      "failedToRevokeAccess": "Kurssin käyttöoikeuden poisto epäonnistui",
      "accessGranted": "Kurssin käyttöoikeus on myönnetty onnistuneesti",
      "multipleAccessGranted": "{count} kurssia on myönnetty onnistuneesti",
      "failedToGrantAccess": "Kurssin käyttöoikeuden myöntäminen epäonnistui"
    },
    "ariaLabels": {
      "courseCard": "Kurssikortti",
      "courseCardActions": "Kurssikortin toiminnot",
      "editCourse": "Muokkaa kurssia",
      "deleteCourse": "Poista kurssi",
      "moveCard": "Siirrä korttia",
      "copyLink": "Kopioi linkki",
      "cardImage": "Kurssikortin kuva"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Virhe tiedostoa ladattaessa"
    },
    "uploadLinkVideo": "Lataa/linkitä video",
    "removeMedia": "Poista {fileName} mediaa"
  },
  "leaderboard": {
    "level": "Taso",
    "lastUpdated": "Päivitetty viimeksi",
    "members": "Jäsenet",
    "percentOfMembers": "{percentage} % jäsenistä",
    "rewards": "Palkinnot",
    "allTime": "Koko ajalta",
    "pointsToLevelUp": "pistettä seuraavalle tasolle",
    "points": "Pisteet",
    "leaderboard7d": "Tulostaulu (7 päivää)",
    "leaderboard30d": "Tulostaulu (30 päivää)",
    "leaderboardAlltime": "Tulostaulu (koko ajalta)",
    "yourRank": "Oma sijoituksesi",
    "noActivityToShow": "Ei näytettävää toimintaa",
    "rewardsWillBeDisplayedHere": "Palkinnot näytetään tässä",
    "seeAllLeaderboards": "Katso kaikki tulostaulut",
    "addRewards": "Lisää palkintoja",
    "howPointsWork": "Ansaitset pisteitä, kun muut jäsenet tykkäävät viesteistäsi tai kommenteistasi. 1 tykkäys = 1 piste. Tämä rohkaisee käyttäjiä tuottamaan laadukasta sisältöä ja olemaan vuorovaikutuksessa muiden yhteisön jäsenten kanssa.",
    "levels": "Tasot",
    "levelsDescription": "Voit korottaa tasoasi keräämällä pisteitä. Nykyinen taso näkyy avatarisi oikeassa alakulmassa. Voit tarkistaa seuraavalle tasolle pääsemiseen tarvittavan pistemäärän Tulostaulu-sivun edistymispalkista.",
    "pointsAndLevels": "Pisteet & Kerrokset"
  },
  "events": {
    "createEvent": "Luo tapahtuma",
    "dragAndDrop": "Vedä ja pudota SVG, PNG tai JPG (enint. 800 x 400 pikseliä)",
    "editEvent": "Muokkaa tapahtumaa",
    "addEvent": "Lisää tapahtuma",
    "paymentDetails": "Maksutiedot",
    "event": "Tapahtuma",
    "goBack": "Takaisin",
    "cancelEdit": "Peruuta muokkaus",
    "cancelEvent": "Peruuta tapahtuma",
    "next": "Seuraava",
    "saveEvent": "Tallenna tapahtuma",
    "editRecurringEvent": "Muokkaa toistuvaa tapahtumaa",
    "thisEvent": "Tämä tapahtuma",
    "thisAndFollowingEvents": "Tämä ja seuraavat tapahtumat",
    "ok": "OK",
    "deleteRecurringEvent": "Poista toistuva tapahtuma",
    "allEvents": "Kaikki tapahtumat",
    "adminsFreeForPaidEvents": " * Ylläpitäjät voivat ilmoittautua Maksettu tapahtumat for Ilmaisille -tapahtumaan",
    "deleteEvent": "Poista tapahtuma",
    "onceEventDeleted": "Kun tapahtuma on poistettu, se ei enää näy kalenterissasi.",
    "toRegister": "ilmoittautumista varten",
    "calendar": "Kalenteri",
    "addToCalendar": "Lisää kalenteriin",
    "declineRegistration": "Hylkää",
    "paymentFailedMessage": "Maksu epäonnistui odottamattomien olosuhteiden vuoksi! Yritä myöhemmin uudelleen.",
    "upcoming": "Tulevat",
    "noMoreEvents": "Näytettäviä tapahtumia ei ole enempää",
    "joinGroupToRegister": "Sinun on kuuluttava tähän ryhmään, jotta voit ilmoittautua tähän tapahtumaan",
    "past": "Aiemmat",
    "youHaveRegisteredForOneEvent": "Olet ilmoittautunut yhteen tapahtumaan. Lähetämme sinulle muistutuksen vuorokautta ennen jokaista tapahtumaa.",
    "upcomingEvents": "Tulevat tapahtumat",
    "noUpcomingEvents": "Ei tulevia tapahtumia",
    "pastEvents": "Menneet tapahtumat",
    "noPastEvents": "Ei menneitä tapahtumia",
    "noMatchingEventFound": "Hakuehdoilla ei löytynyt tapahtumia",
    "recordings": "Tallenteet",
    "week": "Viikko",
    "month": "Kuukausi",
    "today": "Tänään",
    "registrationConfirmed": "Ilmoittautuminen Vahvistettu henkilölle {event}.",
    "eventDeletedOrRestricted": "Tapahtuma on poistettu tai sitä on rajoitettu",
    "eventDeleted": "Tapahtuma on poistettu",
    "eventRestricted": "Sinulla ei ole tämän tapahtuman käyttöoikeutta",
    "validations": {
      "titleValidation": "Otsikko on pakollinen",
      "colorValidation": "Väri on pakollinen",
      "startTimeValidation": "Alkamisaika on pakollinen",
      "endTimeValidation": "Päättymisaika on pakollinen",
      "endTimeAfterStartTime": "Päättymisajan on oltava alkamisajan jälkeen!",
      "startTimeMustBeInFuture": "Alkamisajan tulee olla tulevaisuudessa",
      "locationValidation": "Sijainti on pakollinen",
      "locationValidationMobile": "Sijainti on pakollinen",
      "locationUrlValidation": "Hyväksyttävä sijainnin URL tarvitaan",
      "descriptionValidation": "Kuvaus on pakollinen",
      "descriptionValidationMaxLength": "Kuvauksen pituus voi olla enintään 300 merkkiä",
      "recaptchaError": "Vahvistus epäonnistui! Yritä uudelleen",
      "repeatIntervalValidation": "Toistuminen on määritettävä",
      "repeatIntervalValidator": "Toistovälin tulee olla joko päivä, viikko, kuukausi tai vuosi",
      "repeatIntervalRequired": "Toistoväli on pakollinen",
      "repeatOccurrenceValidator": "Toistumiskertojen tulee olla suurempi kuin 0",
      "repeatOccurrenceRequired": "Toistumiskerrat on pakollinen",
      "invalidDateFormat": "Virheellinen päivämäärämuoto",
      "endDateMustBeAfterStartDate": "Päättymispäivän on oltava tapahtuman alkamispäivän jälkeen",
      "recurringEndDateValidation": "Toistumisen päättymispäivä on pakollinen",
      "repeatsOnValidation": "Valitse vähintään yksi päivä",
      "invalidDaySelection": "Virheellinen päivävalinta",
      "endOptionRequired": "Päättymisvaihtoehto on pakollinen",
      "levelValidation": "Valitse taso",
      "courseValidation": "Valitse kurssi",
      "channelValidation": "Valitse kanava",
      "eventPriceValidation": "Hinta on Pakollinen ja sen on oltava suurempi kuin {min}"
    },
    "placeholders": {
      "selectStartTime": "Valitse alkamisaika",
      "selectEndTime": "Valitse päättymisaika",
      "selectLocation": "Valitse sijainti",
      "locationUrl": "Linkki/osoite",
      "description": "Kuvaus",
      "selectRecurringEndDate": "Valitse toistumisen päättymispäivä",
      "selectDate": "Valitse päivämäärä",
      "event": "Tapahtuma",
      "selectColor": "Valitse väri",
      "selectAttendees": "Valitse osallistujat",
      "selectPrivateChannel": "Valitse yksityinen kanava",
      "selectCourse": "Valitse kurssi",
      "selectLevels": "Valitse tasot",
      "selectCalendar": "Valitse kalenteri"
    },
    "labels": {
      "startTime": "Alkamisaika",
      "endTime": "Päättymisaika",
      "others": "Muut",
      "oneTimePriceForEventRegistration": "kertamaksu tapahtumaan ilmoittautumisesta.",
      "totalAmount": "Loppusumma",
      "cardAuthorizationText": "Lisäämällä korttisi tietosi hyväksyt, että {locationName} veloittaa tulevat maksut tältä kortilta ehtojensa mukaisesti.",
      "secureAndSafePayments": "Täysin turvalliset ja suojatut maksut",
      "day": "päivän välein",
      "week": "viikon välein",
      "month": "kuukauden välein",
      "year": "vuoden välein",
      "recurringEvent": "Onko kyseessä toistuva tapahtuma?",
      "repeatsEvery": "Toistuu",
      "repeatsOn": "Toistuu",
      "end": "Päättyminen",
      "ends": "Sulkea",
      "neverEnds": "Ei pääty koskaan",
      "orange": "Oranssi",
      "red": "Punainen",
      "blue": "Sininen",
      "green": "Vihreä",
      "violet": "Violetti",
      "purple": "Purppuranpunainen",
      "yellow": "Keltainen",
      "title": "Otsikko",
      "color": "Väri",
      "allMembers": "Kaikki jäsenet",
      "membersAtALevel": "Jäsenet tasolla",
      "membersOfACourse": "Kurssin jäsenet",
      "membersOfAPrivateChannel": "Yksityisen kanavan jäsenet",
      "whoCanAttendTheEvent": "Ketkä voivat osallistua tapahtumaan?",
      "channel": "Kanava",
      "course": "Kurssi",
      "level": "Taso",
      "remindAttendeesByEmail": "Muistuta osallistujia Kautta Sähköposti 1 Päivä Ennen",
      "hideLocationFromNonAttendees": "Piilota sijainti muilta kuin osallistujilta.",
      "addChargesToTheEvent": "Lisätä laskutus tapahtumaan",
      "noPaymentRequired": "Ei maksua Pakollinen",
      "location": "Sijainti",
      "link": "Linkki",
      "description": "Kuvaus",
      "timezone": "Aikavyöhyke",
      "eventType": "Tapahtuman tyyppi",
      "eventTypeChangeWarning": "Dynaaminen to the Tapahtuman tyypin hinnoitteluun tulee Käyttää Tai muita tapahtumia in .",
      "never": "Ei koskaan",
      "on": "Päällä",
      "after": "Jälkeen:",
      "occurrences": "tapahtumat",
      "selectEventEnd": "Valita Kun the Tapahtuma tulee Loppu.",
      "turnOnTestPayments": "Kääntää Päällä Testata-maksut Kautta a Testata kortti",
      "pay": "Maksaa",
      "hideAttendees": "Piilottaa osallistujat - Ryhmä Jäsenet",
      "guests": "{count} vierasta",
      "guestList": "Vieras Luettelo",
      "noAttendees": "Ei vielä osallistujia",
      "viewAttendees": "Katsoa osallistujat",
      "exportAttendees": "Viedä osallistujat"
    },
    "notifications": {
      "eventCreated": "Tapahtuma onnistui Luotu!",
      "pickImageFailed": "Kuvan valinta epäonnistui",
      "pickImageFailedContent": "Kuvaa valittaessa tapahtui virhe.",
      "eventUpdated": "Tapahtuma onnistui Päivitetty!",
      "eventCreationFailed": "Tapahtuma luominen epäonnistui!",
      "eventUpdateFailed": "Tapahtuma päivitys epäonnistui!",
      "EVENT_CREATE_INVALID_TIME_RANGE": "Aloitusajan on oltava ennen päättymisaikaa.",
      "EVENT_CREATE_PAST_TIME_NOT_ALLOWED": "Aloitusajan on oltava tulevaisuudessa.",
      "EVENT_CREATE_DURATION_EXCEEDED": "Tapahtuman kesto ylittää enimmäisrajan.",
      "EVENT_CREATE_FAILED": "Tapahtuman luominen ei onnistu. Yritä uudelleen.",
      "EVENT_UPDATE_NOT_FOUND": "Tapahtumaa ei voitu päivittää, koska sitä ei löytynyt.",
      "EVENT_UPDATE_UNAUTHORIZED": "Sinulla ei ole oikeutta päivittää tätä tapahtumaa.",
      "EVENT_UPDATE_INVALID_OPERATION": "Tämä tapahtuman päivitystoiminta ei ole sallittu.",
      "eventDeleted": "Tapahtuma poistettu!",
      "eventDeletionFailed": "Tapahtuman poistaminen epäonnistui!",
      "paymentFailed": "Maksu epäonnistui!",
      "registrationSuccessful": "Ilmoittautuminen onnistui!",
      "registrationFailed": "Ilmoittautuminen epäonnistui!",
      "addToCalendarFailed": "Tapahtuman lisääminen kalenteriin epäonnistui!",
      "locationDetailsCopied": "Sijaintitiedot kopioitu leikepöydälle!",
      "registrationDeclined": "Ilmoittautuminen hylätty!",
      "registrationDeclinedFailed": "Ilmoittautumisen hylkääminen epäonnistui!",
      "fetchAttendeesFailed": "Osallistujien lataaminen epäonnistui",
      "emailCopied": "Sähköpostikopio leikepöydälle",
      "exportAttendeesFailed": "Osallistujien vienti epäonnistui"
    },
    "selectCalendar": "Valitse kalenteri",
    "eventImage": "Tapahtumakuva",
    "errorLoadingEvent": "Epäonnistunut tapahtuman lataaminen"
  },
  "login": {
    "invite": "kutsui sinut liittymään seuraavaan:"
  },
  "contentReports": {
    "contentDeleted": "Sisältö on poistettu!",
    "noActionTaken": "Ilmiannetun sisällön suhteen ei ole ryhdytty toimenpiteisiin!",
    "reportedContentNotFound": "Ilmiannettua sisältöä ei löydy. Asia on saatettu jo käsitellä.",
    "reported": "Ilmiannettu",
    "viewAllReportedContentHere": "Täältä näet kaiken ilmiannetun sisällön",
    "takeActionOnReportedContent": "Ryhdy toimenpiteisiin ilmiannetun sisällön suhteen",
    "andOthers": "ja {count} muuta",
    "reportedThisPost": "ilmiantoi tämän julkaisun",
    "keep": "SÄILYTÄ",
    "remove": "POISTA",
    "deleteContent": "Poista sisältö",
    "deleteConfirmation": "Haluatko varmasti poistaa tämän sisällön?",
    "noMemberReportedContent": "Ei jäsenten ilmiantamaa sisältöä",
    "whenMembersReportPostsOrComments": "Kun jäsenet tekevät ilmiantoja julkaisuista tai kommenteista, ne ilmestyvät tänne tarkistettavaksi. Voit säilyttää tai poistaa ne sekä jäädyttää, poistaa tai estää niitä tehneet jäsenet.",
    "reportedThisComment": "Olet ilmoittanut tästä kommentista"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Tämä sisältö ei ole tällä hetkellä saatavilla",
    "whenThisHappens": "Tämä johtuu yleensä siitä, että omistaja on jakanut sen vain pienelle käyttäjäryhmälle tai muuttanut sitä, ketkä voivat nähdä sen. Se on myös saatettu poistaa."
  },
  "search": {
    "noResultsFor": "0 tulosta haulle \"{query}\" yhteisössä",
    "noResultsFound": "Tuloksia ei löytynyt"
  },
  "noCommunities": {
    "noCommunitiesFound": "Yhteisöjä ei löytynyt",
    "startCreatingYourOwnCommunities": "Aloita omien yhteisöjen luominen ja tee lähempää tuttavuutta yleisöösi!",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Ei liittynyt",
      "communities": "Yhteisöt",
      "yet": "Vielä"
    },
    "noCommunitiesFoundGokollabDescription": "Etsi tiloja, joissa ihmiset jakavat ideoita, tukevat toisiaan ja kasvavat yhdessä."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Ei ole ilmoittautunut seuraavaan:",
      "course": "Kurssi",
      "yet": "Vielä"
    },
    "noCoursesFoundGokollabDescription": "Tutustu vaikuttaviin kursseihin, jotka on suunniteltu auttamaan sinua oppimaan, kehittymään ja menestymään."
  },
  "notFound": {
    "ohNo": "voi ei...",
    "weHaveHadAnError": "Palvelussamme on sattunut virhe",
    "error404": "Virhe 404",
    "sorryPleaseCheckBack": "Pahoittelut... yritä uudelleen hetken kuluttua."
  },
  "time": {
    "justNow": "Juuri nyt",
    "timeAgo": "{value}{unit} sitten",
    "timeAgoFull": "{value} {unit} sitten",
    "units": {
      "year": "v",
      "years": "vuotta",
      "month": "kk",
      "months": "kuukautta",
      "week": "vk",
      "weeks": "viikkoa",
      "day": "p",
      "days": "päivää",
      "hour": "t",
      "hours": "tunnit",
      "minute": "m",
      "minutes": "minuuttia",
      "second": "s",
      "seconds": "Sekunnit",
      "monthly": "Kuukausitttainen",
      "weekly": "Viikoittainen",
      "annually": "Vuosittain"
    },
    "dayAbbreviations": {
      "mon": "ma",
      "tue": "ti",
      "wed": "ke",
      "thu": "to",
      "fri": "pe",
      "sat": "la",
      "sun": "su"
    }
  },
  "emojiPicker": {
    "notfound": "Ei emoji-tuloksia",
    "recent": "Usein käytetty",
    "smileys": "Hymiöt ja hymiö",
    "people": "Ihmiset ja Runko",
    "nature": "Eläimet ja luonto",
    "foods": "Ruoka ja juoma",
    "activity": "Toiminta",
    "places": "Matkailu ja Paikat",
    "objects": "Objektit",
    "symbols": "Symbolit",
    "flags": "Liput",
    "custom": "Mukautettu"
  },
  "topNavBarHeaderText": {
    "discussion": "Keskustelu",
    "learning": "oppiminen",
    "people": "Ihmiset"
  },
  "globalUserProfile": {
    "ownedBy": "Omistaja: {name}",
    "memberships": "Jäsenyydet",
    "membershipsInCommon": "Jäsenyydet ({count} yhteistä)",
    "membersCount": "{count} jäsentä",
    "contributions": "{count} osallistumista ryhmään {group}",
    "contributionsFor": "Osallistumiset ryhmään",
    "justPosts": "Pelkästään julkaisut",
    "postAndComments": "Julkaisu ja kommentit",
    "followSuccess": "Olet alkanut seurata käyttäjää",
    "unfollowSuccess": "Et enää seuraa käyttäjää"
  },
  "profile": {
    "active": "Aktiivinen",
    "ago": "sitten",
    "bio": "Bio"
  },
  "golive": {
    "golive": "Aloita suora lähetys",
    "liveRoom": "Live-istunto",
    "defaultEventTitle": "Yhteisön live-tapahtuma",
    "meetingCreationFailed": "GoLive-kokouksen luominen ei onnistunut. Yritä uudelleen.",
    "selectVideoSourceToStart": "Valitse videolähde suoratoiston aloittamiseksi",
    "chooseHowToGoLive": "Valitse, miten haluat aloittaa suoran lähetyksen",
    "flipCamera": "Käännä kamera",
    "participants": "Osallistujat",
    "chats": "Keskustelut",
    "react": "Reagoi",
    "raise": "Nosta",
    "shareScreen": "Jaa",
    "letsCheckYourCamAndMic": "Tarkistetaan kamera ja mikrofoni",
    "hostedBy": "Isännöi",
    "join": "Liity",
    "needCameraPermission": "Tarvitaan kameran käyttöoikeus",
    "needMicrophonePermission": "Tarvitaan mikrofonin käyttöoikeus",
    "needSpeakerPermission": "Tarvitaan kaiuttimen käyttöoikeus",
    "createLiveVideo": "Luo live-video",
    "host": "Isäntä",
    "chooseWhereToPost": "Valitse julkaisupaikka",
    "whenAreYouGoingLive": "Milloin on aiottu julkaisuajankohta?",
    "postingIn": "julkaisemassa",
    "live": "Suora",
    "postDetails": "Julkaisun tiedot",
    "streamingSoftware": "Suoratoisto-ohjelmisto",
    "streamingSoftwareDescription": "Voit käyttää suoratoisto-ohjelmistoa, kuten Zoom, OBS tai StreamYard, suoratoistoon. Kopioi annettu suoratoiston URL ja suoratoiston avain suoratoisto-ohjelmiston asetuksiin. Kun asetukset on määritetty, aloita lähetys ohjelmistossa, ja se suoratoistetaan automaattisesti valitsemallesi alustalle.",
    "streamKey": "Suoratoiston avain",
    "streamKeyDescription": "Tätä voi käyttää uudelleen jokainen kerta, kun aloitat suoran lähetyksen. Voit lähettää vain yhden live-videon kerrallaan pysyvällä suoratoiston avaimellasi.",
    "serverUrl": "Palvelimen URL",
    "serverUrlDescription": "Tätä voidaan kutsua suoratoisto-ohjelmistossasi nimellä \"URL\" tai \"Osoite\".",
    "selectVideoSource": "Valitse videolähde",
    "copyPasteStreamKey": "Kopioi ja liitä suoratoistoavain suoratoisto-ohjelmistoosi.",
    "copyPasteServerUrl": "Kopioi ja liitä palvelimen URL-osoite suoratoisto-ohjelmistoosi.",
    "addPostDetails": "Lisää julkaisun tiedot",
    "enterTitle": "Anna otsikko",
    "notifyMembers": "Ilmoita jäsenille, että olet aloittamassa suoran lähetyksen (lähetetään vain sovelluksen sisäisiä ja push-ilmoituksia)",
    "notifyMembersMobile": "Ilmoita jäsenille, että olet julkaisemassa",
    "meetingRoom": "Kokoushuone",
    "meetingRoomDescription": "Käytä kokoushuoneiden ominaisuutta isännöidäksesi suoria istuntoja, joissa kaikki jäsenet voivat kytkeä verkkokameransa päälle, poistaa mykistyksen ja olla vuorovaikutuksessa reaaliaikaisesti. Tämä luo Zoomin tai Google Meetin kaltaisen virtuaalisen huonekokemuksen, joka mahdollistaa sen, että kaikki voivat nähdä ja keskustella toistensa kanssa kasvotusten.",
    "cameraControls": "Kameran säätimet",
    "cameraControlsTooltip": "Määritä kamera- ja ääniasetukset ennen kuin aloitat suoran lähetyksen. Varmista, että kamera ja mikrofoni on kytkettyinä oikein ja että niillä on tarvittavat käyttöoikeudet.",
    "selectMediaSource": "Valitse medialähde",
    "startScreenShare": "Aloitussivun jakaminen",
    "stopScreenShare": "Pysäytyssivun jakaminen",
    "wasLive": "oli suorana",
    "isLive": "on suorana",
    "goingLive": "alkaa suorana",
    "tapToAddDescription": "Lisää kuvaus napauttamalla...",
    "selectChannel": "Valitse kanava",
    "saveAsPost": "Pidä suoratoisto julkaisuna",
    "selectVideoSourceTooltip": "Voit valita suoratoisto-ohjelmiston tai verkkokameran välillä, kun siirryt suoratoistoon:\n\n1. Suoratoistosovellukset\n • Tarjoamme suoratoistoavaimen ja suoratoiston URL-osoitteen.\n   • Sinun on määritettävä nämä Zoomissa, OBS:ssä tai missä tahansa kolmannen osapuolen sovelluksissa, jotka tukevat live-suoratoistoa.\n\n2. Verkkokamera\n • Siirry live-suoratoistoon kameraa ja mikrofonia käyttämällä.\n   • Jäsenet voivat katsoa live-suoratoistoa ja olla vuorovaikutuksessa live-keskustelun kautta.\n   • Isäntänä voitte hallinnoida ja peruuttaa kameran tai mikrofonin käyttöoikeuden milloin tahansa.",
    "pleaseSelectCameraMicrophoneSpeaker": "Valitse kamera, mikrofoni ja kaiutin",
    "pleaseStartStreamBeforeGoingLive": "Aloita suoratoisto ennen live-suoratoiston aloittamista",
    "watching": "Katsotaan",
    "processingRecording": "Suoritetaan tietuetta",
    "recordingFailed": "Tallenne ei ole saatavilla",
    "recordingFailedDescription": "Tämän live-istunnon käsittelyssä ilmeni ongelma, eikä tallennetta voitu tallentaa",
    "streamEndedRecordingWillBeAvailableSoon": "Suoratoisto päättyi. Tallennetta käsitellään ja se tulee saataville pian.",
    "joinStream": "Liity suoratoistoon",
    "recordingInProgress": "Tallennus on käynnissä",
    "recordingNotAvailable": "Tallennus epäonnistui",
    "leaveSession": "Poistua istunnosta",
    "endSession": "Lopeta istunto",
    "rec": "REC",
    "selectCamera": "Valitse kamera",
    "noCamerasFound": "Kameroita ei löydetty",
    "cameraPermissionNeeded": "Kameran käyttöoikeus tarvitaan",
    "leave": "Poistu",
    "chooseMicCam": "Valitse mikrofoni/kamera",
    "selectMicrophone": "Valitse mikrofoni",
    "selectSpeaker": "Valitse puhuja",
    "noMicrophonesFound": "Mikrofoneja ei löydetty",
    "noSpeakersFound": "Kaiuttimia ei löydetty",
    "microphonePermissionNeeded": "Mikrofonin käyttöoikeus tarvitaan",
    "speakerPermissionNeeded": "Kaiuttimen käyttöoikeus tarvitaan",
    "noParticipantOpenCamOrMic": "Tätä kokousta ei tallennettu, koska kukaan jäsenistä ei ottanut mikrofonia tai kameraa käyttöön. Tallenteet luodaan vain, kun vähintään yksi osallistuja on vuorovaikutuksessa."
  }
}
